import { React, useState, useEffect, useContext, useRef } from 'react'
import { Button } from 'bootstrap'
import "../css/PagesCommonStyle.css"
import { faL, faMagnifyingGlass, faPrint } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faFilePdf, faTrashCan } from '@fortawesome/free-regular-svg-icons'
import { useSelector } from 'react-redux';
import { faTriangleExclamation, faStar, faCircleInfo, faXmark, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'
import { APIConstants, IntelliBillConstants, CommonAPIConstants, ClaimApprovalConstants, RejectedConstants, FilesAPIConstants } from '../utilities/Constants'
import Draggable from 'react-draggable'
import * as XLSX from 'xlsx';
import { Link } from 'react-router-dom'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format, set } from 'date-fns';
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import { RejectedClaim } from '../redux/actions/userActions'



const RejectedClaims = () => {

  const dispatch = useDispatch();


  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };


  const today = new Date();


  const formatCurDate = format(today, 'MM/dd/yyyy');

  // Default value for the input is the current date
  const defaultDate = getCurrentDate();
  const defaultFromDate = new Date('2015-01-01');



  const [isHideChecked, setIsHideChecked] = useState(false);
  const [updatedTabledata, setUpdatedTableData] = useState([]);
  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState(''); // State to store start date
  const [endDate, setEndDate] = useState('');     // State to store end date
  const [loading, setLoading] = useState(true);

  const [ServiceLocations, setServiceLocations] = useState([]);
  const [selectedCMS33a, setSelectedCMS33a] = useState("");
  const [selectedCMS33b, setSelectedCMS33b] = useState('0');
  const [selectedBillingNPI, setSelectedBillingNPI] = useState('9875632410');
  const [selectedPracticeProvider, setSelectedPracticeProvider] = useState('0');
  const [selectedProvidersCategory, setSelectedProvidersCategory] = useState('0');
  const [selectedSearchFilter, setSelectedSearchFilter] = useState('submitter');
  const [sFilterType, setsFilterType] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('0');
  const [searchByLoaction, setSearchByLocation] = useState('-1');
  const [selectedStatusRadioButton, setSelectedStatusRadioButton] = useState('0');
  const [selectedCheckedRadioButton, setSelectedCheckedRadioButton] = useState('0');
  const [selectedServiceLocation, setSelectedServicelocation] = useState('0');
  const [selectedFilterProvider, setSelectedFilterProvider] = useState('0');
  const [selectedSuggestion, setSelectedSuggestion] = useState(null);
  const [selectedData, setSelectedData] = useState('');
  const [selectedProviderSuggestion, setSelectedProviderSuggestion] = useState([]);
  const [selectedCPTSuggestion, setSelectedCPTSuggestion] = useState(null);
  const [filteredData, setFilteredData] = useState([]);

  const [locations, setLocations] = useState([]);
  const [cms33aData, setCMS33aData] = useState([]);
  const [cms33bData, setCMS33bData] = useState([]);
  const [providerCategory, setProviderCategory] = useState([]);
  const [searchFilterData, setSearchFilterData] = useState([]);
  const [practiceProvider, setPracticeProvider] = useState([]);
  const [statusRadioButton, setStatusRadioButton] = useState([]);
  const [checkedRadioButton, setCheckedRadioButton] = useState([]);
  const [selectClearinghouse, setSelectClearingHouse] = useState([]);
  const [ClearingHouse, setClearingHouse] = useState('');
  const [BillingNPIs, setBillingNPIs] = useState([]);
  const [rows, setRows] = useState([]);

  const [selectedService, setSelectedService] = useState('0');

  const [searchText, setSearchText] = useState('');
  const [searchPatientText, setSearchPatientText] = useState('');
  const [searchProvidersText, setSearchProvidersText] = useState('');
  const [ProviderRoleID, setProviderRoleID] = useState('');

  const [searchInsuranceText, setSearchInsuranceText] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [isTextBoxDisabled, setIsTextBoxDisabled] = useState(false);
  const [issuggestionBoxDisabled, setIsSuggestionBoxDisabled] = useState(true);
  const [sPatID, setSPatID] = useState('0');
  const [sClaimStatus, setsClaimStatus] = useState('0');
  const [sCheckedInStatus, setsCheckedInStatus] = useState('0');
  const [rowsValidation, setRowsValidation] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [tableDetails, setTableDetails] = useState([]);
  const [tableInsDetails, setTableInsDetails] = useState([]);
  const [checkEligibility, setCheckEligibility] = useState([]);
  const [selectedClaims, setSelectedClaims] = useState([]);
  const [selectAllDropDown, setSelectAllDropDown] = useState([]);
  const [checkboxes, setCheckboxes] = useState();

  const [searchPatientData, setSearchPatientData] = useState([]);
  const [suggestionProviders, setSuggestionProviders] = useState('');
  const [suggestionInsurance, setSuggestionInsurance] = useState('');
  const [patientList, setPatientList] = useState('');

  const [activeRow, setActiveRow] = useState(null);


  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedLocationRows, setSelectedLocationRows] = useState([]);
  const [selectedValueLocRows, setSelectedValueLocRows] = useState([]);
  const [UnitChargeRows, setUnitChargeRows] = useState([]);
  const [unitCheckbox, setUnitCheckbox] = useState([]);
  const [diag4AllCheckbox, setDiag4AllCheckbox] = useState([]);
  const [diag3AllCheckbox, setDiag3AllCheckbox] = useState([]);
  const [diag2AllCheckbox, setDiag2AllCheckbox] = useState([]);
  const [diag1AllCheckbox, setDiag1AllCheckbox] = useState([]);
  const [mod3AllCheckbox, setMod3AllCheckbox] = useState([]);
  const [mod2AllCheckbox, setMod2AllCheckbox] = useState([]);
  const [mod1AllCheckbox, setMod1AllCheckbox] = useState([]);
  const [cptAllCheckbox, setCptAllCheckbox] = useState([]);
  const [providerAllCheckbox, setProviderAllCheckbox] = useState([]);
  const [insuranceAllCheckbox, setInsuranceAllCheckbox] = useState([]);
  const [filteredTableDetails, setFilteredTableDetails] = useState(tableDetails);
  const [providerDataList, setProviderDataList] = useState([]);
  const [cptDataList, setCptDataList] = useState([]);
  const [modDataList, setModDataList] = useState([]);
  const [mod2DataList, setMod2DataList] = useState([]);
  const [mod3DataList, setMod3DataList] = useState([]);
  const [diag1DataList, setDiag1DataList] = useState([]);
  const [diag2DataList, setDiag2DataList] = useState([]);
  const [diag3DataList, setDiag3DataList] = useState([]);
  const [diag4DataList, setDiag4DataList] = useState([]);
  const [selectedInsRows, setSelectedInsRows] = useState([]);
  const [selectedCPTCode, setSelectedCPTCode] = useState([]);
  const [selectedCPTPatientID, setSelectedCPTPatientID] = useState([]);
  const [selectedPatientID, setSelectedPatientID] = useState([]);
  const [selectedDiag1ID, setSelectedDiag1ID] = useState('');
  const [selectedDiag2ID, setSelectedDiag2ID] = useState('');
  const [selectedDiag3ID, setSelectedDiag3ID] = useState('');
  const [selectedDiag4ID, setSelectedDiag4ID] = useState('');
  const [newRows, setNewRows] = useState([]);

  const [searchByDOS, setSearchByDOS] = useState('');
  const [searchByPatient, setSearchByPatient] = useState('');
  const [searchByDOB, setSearchByDOB] = useState('');
  const [searchByInsuranceID, setSearchByInsuranceID] = useState('');
  const [searchByProvider, setSearchByProvider] = useState('');
  const [searchByCPT, setSearchByCPT] = useState('');
  const [searchByMod1, setSearchByMod1] = useState('');
  const [searchByMod2, setSearchByMod2] = useState('');
  const [searchByMod3, setSearchByMod3] = useState('');
  const [searchByICD1, setSearchByICD1] = useState('');
  const [searchByICD2, setSearchByICD2] = useState('');
  const [searchByICD3, setSearchByICD3] = useState('');
  const [searchByICD4, setSearchByICD4] = useState('');
  const [searchByClaim, setSearchByClaim] = useState('');
  const [searchByReasonCode, setSearchByReasonCode] = useState('');
  const [searchByReason, setSearchByReason] = useState('');

  const [selectedCptValue, setSelectedCptValue] = useState('');
  const [selectedMod1Value, setSelectedMod1Value] = useState('');
  const [selectedMod2ListVal, setSelectedMod2ListVal] = useState('');
  const [selectedMod3ListVal, setSelectedMod3ListVal] = useState('');
  const [selectedDiag1List, setSelectedDiag1List] = useState('');
  const [selectedDiag2List, setSelectedDiag2List] = useState('');
  const [selectedDiag3List, setSelectedDiag3List] = useState('');
  const [selectedDiag4List, setSelectedDiag4List] = useState('');

  const [cptValueList, setCptValueList] = useState([]);
  const [mod1List, setMod1List] = useState([]);
  const [mod2List, setMod2List] = useState([]);
  const [mod3List, setMod3List] = useState([]);
  const [diag1List, setDiag1List] = useState([]);
  const [diag2List, setDiag2List] = useState([]);
  const [diag3List, setDiag3List] = useState([]);
  const [diag4List, setDiag4List] = useState([]);


  const [selectedProviderText, setSelectedProviderText] = useState('');
  const [selectedCPTList, setSelectedCPTList] = useState('');
  const [selectedModList, setSelectedModList] = useState('');
  const [selectedMod2Value, setSelectedMod2Value] = useState('');
  const [selectedMod3Value, setSelectedMod3Value] = useState('');
  const [selectedDiag1Value, setSelectedDiag1Value] = useState('');
  const [selectedDiag2Value, setSelectedDiag2Value] = useState('');
  const [selectedDiag3Value, setSelectedDiag3Value] = useState('');
  const [selectedDiag4Value, setSelectedDiag4Value] = useState('');
  const [selectedUnitValue, setSelectedUnitValue] = useState('');
  const [selectedUnitChargeValue, setSelectedUnitChargeValue] = useState('');

  const [selectedTextField, setSelectedTextField] = useState('');
  const [selectedValueField, setSelectedValueField] = useState('');
  const [selectLocationID, setSelectLocationID] = useState('-1');

  const [showSelectErrorModal, setShowSelectErrorModal] = useState(false);
  const [showICDErrorModal, setShowICDErrorModal] = useState(false);
  const [ICDConfirmSaveModal, setICDConfirmSaveModal] = useState(false);

  const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
  const [showApprovalSaveModal, setShowApprovalSaveModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteSuccessModal, setDeleteSuccessModal] = useState(false);
  const [closeClaimsModal, setCloseClaimsModal] = useState(false);
  const [showFaxModal, setShowFaxModal] = useState(false);
  const [savedRowCount, setSavedRowCount] = useState(0);
  const [deleteRowCount, setDeleteRowCount] = useState(0);
  const [successTimer, setSuccessTimer] = useState(5000);
  const [buttonClicked, setButtonClicked] = useState([]);
  const [showIcon, setShowIcon] = useState(true);
  const [showFaxError, setShowFaxError] = useState(false);
  const [saveFaxError, setSaveFaxError] = useState(false);
  const [showFaxSaveMsg, setShowFaxSaveMsg] = useState(false);
  const [showFaxConfirmMsg, setShowFaxConfirmMsg] = useState(false);

  const [selectedProviderData, setselectedProviderData] = useState('');
  const [selectedMod1Data, setSelectedMod1Data] = useState('');
  const [selectedMod2Data, setSelectedMod2Data] = useState('');
  const [selectedMod3Data, setSelectedMod3Data] = useState('');

  const [sortingOrder, setSortingOrder] = useState('asc');
  const [tableData, setTableData] = useState([]);
  const [sortDosDate, setSortDosDate] = useState('asc');
  const [sortByClaimID, setSortByClaimID] = useState('asc');

  const [sortDateOrder, setSortDateOrder] = useState('asc');
  const [sortedDateData, setSortedDateData] = useState([]);

  const [sortByInsurance, setSortByInsurance] = useState(false);
  const [sortedInsData, setSortedInsData] = useState([]);

  const [selectAllRowsChecked, setSelectAllRowsChecked] = useState(false);
  const [clearingHouseValues, setClearingHouseValues] = useState({});
  const [selectedDropdownValue, setSelectedDropdownValue] = useState('DOS');
  const [insOrPatFilter, setInsOrPatFilter] = useState('');

  const [selected32ACheckbox, setselected32ACheckbox] = useState([]);
  const [selected32AllCheckbox, setselected32AllCheckbox] = useState(false);

  const [selected33ACheckbox, setselected33ACheckbox] = useState([]);
  const [selected33AllCheckbox, setselected33AllCheckbox] = useState(false);
  const [selected33BCheckbox, setselected33BCheckbox] = useState([]);
  const [selected33BAllCheckbox, setselected33BAllCheckbox] = useState(false);

  const [syncedValue, setSyncedValue] = useState('');
  const [syncedUnitchargeVal, setSyncedUnitchargeVal] = useState('');

  const [hasFetched, setHasFetched] = useState(false);

  const [resubmitCodeValue, setresubmitCodeValue] = useState('');
  const [orignalClaimNum, setorignalClaimNum] = useState('');

  const [isStartOpen, setIsStartOpen] = useState(false);
  const [isEndOpen, setIsEndOpen] = useState(false);
  const [physicianDropdownData, setPhysicianDropdownData] = useState([]);

  const navigate = useNavigate();


  const userData = useSelector((state) => state.user.user);
  console.log('userData:', userData);

  localStorage.setItem('userData', JSON.stringify(userData));


  // const storedUserData = JSON.parse(localStorage.getItem('userData'));


  var userPracticeID = userData ? userData.practiceID : null;

  var userId = userData ? userData.userID : null;
  const sAuthToken = useSelector((state) => state.user.token);



  useEffect(() => {

    document.title = 'Workable Claims'
    let timerId;

    if (showSuccessModal || deleteSuccessModal) {
      // Start the timer when the success modal is shown
      timerId = setTimeout(() => {
        setShowSuccessModal(false);
        setDeleteSuccessModal(false);
      }, successTimer);
    }


    return () => {
      clearTimeout(timerId);
    };
  }, [showSuccessModal, successTimer, deleteSuccessModal]);


  const hashParams = new URLSearchParams(window.location.hash.split('?')[1]);

  const DashFromDate = hashParams.get('FromDate');
  const DashToDate = hashParams.get('ToDate');

  useEffect(() => {
    const hashParams = new URLSearchParams(window.location.hash.split('?')[1]);
    const DashFromDate = hashParams.get('FromDate');
    const DashToDate = hashParams.get('ToDate');


    if (DashFromDate && DashToDate) {
      setStartDate(DashFromDate);
      setEndDate(DashToDate);

      handleTableDataClick();
    }
  }, [DashFromDate, DashToDate, startDate, endDate]);






  useEffect(() => {

    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);

    setStartDate(sevenDaysAgo);
    setEndDate(today);
    setSPatID(userId);
    setSearchText(userData.userFullName)

  }, []);







  useEffect(() => {
    const savedData = localStorage.getItem("pendingClaimsData");

    if (savedData) {

      const parsedData = JSON.parse(savedData);


      if (parsedData.sFromDate && parsedData.sToDate) {
        setStartDate(new Date(parsedData.sFromDate));
        setEndDate(new Date(parsedData.sToDate));
      }


      setFilteredTableDetails(parsedData);

    } else {

      const today = new Date();
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 7);

      setStartDate(sevenDaysAgo);
      setEndDate(today);
      setSPatID(userId);
      setSearchText(userData.userFullName)
    }
  }, []);










  useEffect(() => {

    if (!hasFetched && sPatID && searchText) {
      handleTableDataClick();
      setHasFetched(true);
    }
  }, [sPatID, hasFetched, searchText]);





  const handleFromDateChange = (e) => {
    const inputDate = e.target.value;
    if (isValidDate(inputDate)) {
      setStartDate(formatDate(inputDate));
      setEndDate(formatDate(inputDate));
    }
  };







  const handleStartDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setStartDate(formattedDate);
      console.log("Selected start date:", formattedDate);
      setEndDate(date);
      setIsStartOpen(false)
    } else {
      setStartDate(null);
    }
  };


  const handleEndDateChange = (date) => {

    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setEndDate(formattedDate);
      console.log("Selected End date:", formattedDate);
      setIsEndOpen(false)

    } else {
      setEndDate(null);
    }
  };




  const getMonths = (selectedYear) => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    return Array.from({ length: 12 }, (v, k) => {
      if (selectedYear === currentYear && k > currentMonth) {
        return null;
      }
      return (
        <option key={k} value={k}>
          {format(new Date(selectedYear, k), 'MMMM')}
        </option>
      );
    }).filter(option => option !== null);
  };






  const handleTodayClick = (dateType) => {
    const today = new Date();

    if (dateType === "start" && startDate) {
      setStartDate(today);
      setEndDate(today);
      setIsStartOpen(false);
    }

    if (dateType === "end" && endDate) {
      setEndDate(today);
      setIsEndOpen(false);
    }
  };



  const CalendarContainer = ({ children }) => (
    <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
      {children}
      <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
        <button type="button" className='today-btn' onClick={() => handleTodayClick("end")}>
          Today
        </button>

      </div>
    </div>
  );


  const CalendarStartContainer = ({ children }) => (
    <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
      {children}
      <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
        <button type="button" className='today-btn' onClick={() => handleTodayClick("start")}>
          Today
        </button>

      </div>
    </div>
  );





  const isValidDate = (dateString) => {
    const regEx = /^\d{4}-\d{2}-\d{2}$/;
    return dateString.match(regEx) !== null;
  };



  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split('-');
    const formattedMonth = month.padStart(2, '0');
    const formattedDay = day.padStart(2, '0');
    return `${year}-${formattedMonth}-${formattedDay}`;
  };






  const handleHideCheckboxChange = () => {
    setIsHideChecked(!isHideChecked);

    if (isHideChecked) {
      // Reset to original dates
      setStartDate(defaultDate);
      setEndDate(defaultDate);
    } else {
      // Set FROM date to 1/1/2015 and TO date to the current date
      setStartDate('2015-01-01');
      setEndDate(defaultDate);
    }
  };







  // Api Integration of all Dropdowns

  useEffect(() => {



    var inputStruct = {

      LoggedInUserDetails: userData

    }
    console.log('LoginUserData', userData);
    var myInput = { sInputJSON: JSON.stringify(userData) };

    console.log("input of" + IntelliBillConstants.GetIntelliDropDowns, myInput);
    myInput = JSON.stringify(myInput);

    const response = fetch(APIConstants.BASE_URL + IntelliBillConstants.GetIntelliDropDowns, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInput
    })


      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response
        const parsedData = JSON.parse(data.d);
        const dropdownData = parsedData.Data;
        setSelectAllDropDown(dropdownData);

        console.log("dropdownData", dropdownData);

        // Populate the dropdowns with the received data
        setLocations(dropdownData.LocationDetails)


        setServiceLocations(dropdownData.ServiceLocation);
        setPracticeProvider(dropdownData.PracticeProviders);
        setProviderCategory(dropdownData.ProvidersCategories);
        setSearchFilterData(dropdownData.SearchByFilters);
        setStatusRadioButton(dropdownData.StatusRadioButtons);
        setCheckedRadioButton(dropdownData.CheckedInRadioButtons);
        setLoading(false);
      })

      .catch((error) => {
        console.error('Error fetching data: ', error);
      });


  }, [userData]);











  const filteredOptions = ServiceLocations.filter(option => option.ValueField !== "0");
  console.log("filterlocation", filteredOptions);

  useEffect(() => {
    // Reset values when showFaxDialog is true
    if (showFaxModal) {
      setRows([]);
      resetDialogValues();
    }
  }, [showFaxModal]);



  const resetDialogValues = () => {
    // startDate('');
    setSelectedProviderText('');
    setSelectedCPTList('');
    setSelectedModList(null);
    setSelectedUnitValue('');
    setSelectedUnitChargeValue('');
    setSelectedDiag1Value('');
    setSelectedDiag2Value('');
    setSelectedDiag3Value('');
    setSelectedDiag4Value('');
    setSelectedMod2Value('');
    setSelectedMod3Value('');
    setSaveFaxError(false);
    setShowFaxError(false);
    setShowFaxSaveMsg(false);
  };


  const handleLocationChange = (e, item) => {
    const newSelectedLocation = e.target.value;
    setSearchByLocation(newSelectedLocation || (item.LocationId));
    setSelectLocationID(newSelectedLocation);
    console.log("LocationID", selectLocationID);

    localStorage.setItem('selectedLocation', newSelectedLocation);

  };






  const fetchPatientNames = () => {


    var inputJSON = {
      PracticeID: userPracticeID,
      SearchKey: searchText,
      SearchBy: 0,
      isFromLogin: 0
    }

    var sJSONInput = JSON.stringify(inputJSON);
    console.log("input of" + CommonAPIConstants.GetAllPatientNames, inputJSON);

    const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllPatientNames}?sJSONInput=${sJSONInput}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {



        const parsedData = JSON.parse(data);

        const patientData = parsedData.Data



        console.log("patientLists of" + CommonAPIConstants.GetAllPatientNames, patientData);

        if (Array.isArray(patientData)) {
          setSuggestions
            (patientData.map((item) => ({
              label: `${item.LastName}, ${item.FirstName}`,
              val: item.PatientID,
            })));

        } else {


          setSuggestions([]);

          setIsTextBoxDisabled(false);
        }
        console.log("PatientsuggestionsLists", suggestions);

      })
      .catch((error) => {
        console.error('Error fetching patient names:', error);
      });
  };



  const fetchSuggestionPatientNames = () => {


    if (!setSearchPatientText) {
      setSearchPatientData([]);
      return;
    }

    var inputStruct = {

      "sPatName": searchPatientText,
      "sPracticeID": userPracticeID,
      "sLocationID": userData.LocationID

    }

    console.log('LoginuserData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + IntelliBillConstants.GetIntelliPatientNames, myInputData);

    const response = fetch(APIConstants.BASE_URL + IntelliBillConstants.GetIntelliPatientNames, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response


        const parsedData = JSON.parse(data.d);

        const patientData = parsedData.Data


        console.log("patientLists of" + IntelliBillConstants.GetIntelliPatientNames, patientData);

        if (Array.isArray(patientData)) {
          // Filter suggestions based on the label
          const filteredSuggestions = patientData
            .filter(item => item.toLowerCase().includes(searchPatientText.toLowerCase()))
            .map(item => ({
              label: (item.split('$')[0]).split('|')[1].replace(',', '').trim(),
              val: item.split('$')[1].trim(),
            }))
            .filter(item => item.label !== selectedSuggestion && item.label !== '');




          const patientID = patientData.val;

          setSearchPatientData(filteredSuggestions);
          setSelectedCPTPatientID(filteredSuggestions.val);
          console.log("Filtered patientLists of" + IntelliBillConstants.GetIntelliPatientNames, selectedCPTPatientID);





        } else {


          setSearchPatientData([]);


        }
        console.log("PatientsuggestionsLists", searchPatientData);


      })
      .catch((error) => {
        console.error('Error fetching patient names:', error);
      });
  };


  const isMounted = useRef(true);

  useEffect(() => {

    if (isMounted.current) {
      isMounted.current = false;
    } else {
      fetchSuggestionPatientNames(searchPatientText);
    }
  }, [searchPatientText]);





  const handlePatientSuggestion = (suggestion) => {

    setSearchPatientText(`${suggestion.label}`);
    setSelectedSuggestion(suggestion.label);
    setSelectedCPTPatientID(suggestion.val);
    setSearchPatientData([]);
    setShowFaxModal(true);
    setSelectedPatientID(suggestion.val)

    console.log('Selected PatientId suggestion:', selectedPatientID);


  };


  const handleKeyDown = (e) => {
    if (e.key === 'Backspace') {
      // Handle backspace key
      if (searchPatientText === '' && searchPatientData.length > 0) {

        setSearchPatientData([]);


      } else {

        fetchSuggestionPatientNames(searchPatientText.slice(0, -1)) // Remove the last character from searchText

      }
    }
  }


  const fetchProviders = () => {

    var inputJSON = {
      PracticeID: userPracticeID,
      SearchByRole: 0,

    }

    var sJSONInput = JSON.stringify(inputJSON);
    console.log("input of" + CommonAPIConstants.GetRenderingProviders, inputJSON);

    const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetRenderingProviders}?sJSONInput=${sJSONInput}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {



        const parsedData = JSON.parse(data);

        //  const patientData = parsedData.Data



        console.log("ProvidersLists of" + CommonAPIConstants.GetRenderingProviders, parsedData);

        if (Array.isArray(parsedData)) {
          setSuggestions
            (parsedData.map((item) => ({
              label: `${item.FirstName}, ${item.LastName}`,
              val: item.ProviderID,
            })));

        } else {


          setSuggestions([]);

          setIsTextBoxDisabled(false);
        }
        console.log("ProviderssuggestionsLists", suggestions);

      })
      .catch((error) => {
        console.error('Error fetching patient names:', error);
      });



  };




  // const isproviderMounted = useRef(true);


  // useEffect(() => {
  //   if (!isproviderMounted.current) {
  //     if (selectedSearchFilter === 'provider' && searchText) {
  //       fetchProviders();
  //       setIsTextBoxDisabled(false);
  //     }
  //   } else {
  //     isproviderMounted.current = false;
  //   }
  // }, [searchText, selectedSearchFilter]);




  const fetchSearchProviders = () => {

    if (!selectedProviderData) {
      // If searchText is empty, you may want to reset or clear any existing data
      setSearchPatientData([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }


    for (const rowIndex of providerAllCheckbox) {
      const item = tableDetails[rowIndex];

      item.ProvderName = selectedProviderData;
    }


    var inputStruct = {

      "sProviderName": selectedProviderData,
      "sPracticeID": userPracticeID,
      "LoggedInUserDetails": userData

    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + IntelliBillConstants.GetIntelliProvidersNames, myInputData);

    const response = fetch(APIConstants.BASE_URL + IntelliBillConstants.GetIntelliProvidersNames, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const providersData = parsedData.Data

        console.log("providersLists of " + IntelliBillConstants.GetIntelliProvidersNames, providersData);


        if (Array.isArray(providersData)) {
          setSuggestionProviders(providersData.map((item) => ({
            label: (item.split('$')[0]).split('|')[1].trim(),
            val: item.split('$')[1].trim(),
          })));
        } else {
          setSuggestionProviders([]);
        }



      })
      .catch((error) => {
        console.error('Error fetching provider names:', error);

      });
  };




  const handleProviderSuggestion = (suggestion) => {
    setSearchProvidersText(suggestion.label);

    setselectedProviderData(suggestion.label);
    setSearchProvidersText(suggestion.val)
    setSuggestionProviders([]);

    console.log('Selected suggestion:', suggestion);
  };


  const handleProviderKeyDown = (e) => {
    if (e.key === 'Backspace') {
      // Handle backspace key
      if (selectedProviderData === '' && suggestionProviders.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setSuggestionProviders([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchSearchProviders(selectedProviderData.slice(0, -1)) // Remove the last character from searchText

      }
    }
  }






  const fetchInsuranceCompanies = () => {

    var inputJSON = {

      SearchKey: searchText,

    }

    var sJSONInput = JSON.stringify(inputJSON);
    console.log("input of" + CommonAPIConstants.GetInsuCompanyNames, inputJSON);

    const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetInsuCompanyNames}?sJSONInput=${sJSONInput}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {


        const parsedData = JSON.parse(data);

        const InsuranceData = parsedData.Data

        console.log("InsuranceLists of" + CommonAPIConstants.GetInsuCompanyNames, InsuranceData);




        if (Array.isArray(InsuranceData)) {

          const filteredSuggestions = InsuranceData

            .map(item => ({
              label: item.Insurance,
              val: item.InsuID,
            }))
            .filter(item => item.label !== selectedData && item.label !== '');



          setSuggestions(filteredSuggestions);

        } else {
          setSuggestions([]);
          setIsTextBoxDisabled(false);
        }


        console.log("suggestionsLists", suggestions);
        setIsTextBoxDisabled(false);
      })

      .catch((error) => {
        console.error('Error fetching Insurance names:', error);

      });

    return [];

  };




  const isInsMounted = useRef(true);


  useEffect(() => {
    if (!isInsMounted.current) {
      if (selectedSearchFilter === 'Insurance' && searchText) {
        fetchInsuranceCompanies();
        setIsTextBoxDisabled(false);
      }
    } else {
      isInsMounted.current = false;
    }
  }, [searchText, selectedSearchFilter]);






  const fetchSubmittedBy = () => {

    var inputStruct = {


      "sPracticeID": userPracticeID,
      "sUserID": userId,
      "srchKey": searchText


    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + ClaimApprovalConstants.GetSuggestionDropDowns, myInputData);

    const response = fetch(APIConstants.BASE_URL + ClaimApprovalConstants.GetSuggestionDropDowns, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const suggestionData = parsedData.Data

        console.log("Submitted data of " + ClaimApprovalConstants.GetSuggestionDropDowns, suggestionData);


        if (suggestionData.length > 0) {
          setSuggestions(suggestionData.map((item) => ({
            label: item.split('$')[1],
            val: item.split('$')[0]
          })));
        } else {
          setSuggestions([]);
          setIsTextBoxDisabled(false);
        }



      })
      .catch((error) => {
        console.error('Error fetching provider names:', error);

      });



  };



  //Fetch CPT List


  const fetchCPTList = () => {

    if (!selectedCptValue) {
      // If searchText is empty, you may want to reset or clear any existing data
      setCptValueList([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }



    for (const rowIndex of cptAllCheckbox) {
      const item = tableDetails[rowIndex];

      item.CPT = selectedCPTCode;
    }



    var inputStruct =
    {
      cptCode: selectedCptValue
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetCPTList, myInputData);


    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetCPTList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const cptData = parsedData.Data

        const filteredCPTData = cptData.filter(item =>
          `${item.CPT_Code} ${item.CPTDescription}` !== selectedCptValue
        );

        setCptValueList(filteredCPTData);

        console.log("CPTLists of " + CommonAPIConstants.GetCPTList, cptValueList);
      })
      .catch((error) => {
        console.error('Error fetching CPT names:', error);

      });
  };



  useEffect(() => {
    // Fetch suggestions when the component mounts or when searchText changes
    fetchCPTList(selectedCptValue);
  }, [selectedCptValue]);

  const handleCPTList = (suggestion) => {
    setSelectedCptValue(`${suggestion.CPT_Code} ${suggestion.CPTDescription}`);
    setSelectedCPTCode(`${suggestion.CPT_Code}`);
    setCptValueList([]);
    setSelectedUnitValue(1);
    const billingFee = parseFloat(suggestion.Billing_Fee).toFixed(2);
    setSelectedUnitChargeValue(billingFee);

    console.log('Selected suggestion:', billingFee);
  };


  const handleCPTKeyDown = (e) => {
    if (e.key === 'Backspace') {
      // Handle backspace key
      if (selectedCptValue === '' && cptValueList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setCptValueList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchCPTList(selectedCptValue.slice(0, -1)) // Remove the last character from searchText

      }
    }
  }


  // Fetch Mod1 suggestion List



  const fetchMod1List = () => {

    if (!selectedMod1Value) {
      // If searchText is empty, you may want to reset or clear any existing data
      setMod1List([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }


    for (const rowIndex of mod1AllCheckbox) {
      const item = tableDetails[rowIndex];

      item.Mod1 = selectedMod1Data;
    }


    var inputStruct =
    {
      modName: selectedMod1Value
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetModList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        console.log("ModLists of " + CommonAPIConstants.GetModList, modData);


        if (Array.isArray(modData)) {
          setMod1List(
            modData.map((item) => {
              if (item && typeof item === 'object' && 'Value' in item) {
                return {
                  val: item.Value.split(' | ')[0],
                };
              } else {
                console.error('Invalid item in modData:', item);
                return null;
              }
            })
          );
        } else {
          setMod1List([]);
        }


      })
      .catch((error) => {
        console.error('Error fetching Mod names:', error);

      });
  };



  useEffect(() => {

    fetchMod1List(selectedMod1Value);
  }, [selectedMod1Value]);

  const handleMod1List = (suggestion) => {
    const concatenatedValue = `${suggestion.val}-${suggestion.val}`;

    setSelectedMod1Value(concatenatedValue);
    setSelectedMod1Data(suggestion.val)


    console.log('Selected suggestion:', suggestion);
  };


  const handleMod1ListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedMod1Value === '' && modDataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setMod1List([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchModList(selectedMod1Value.slice(0, -1))//Remove the last character from searchText

      }
    }
  }


  //Fetch Mod2 suggestions List


  const fetchMod2Data = () => {

    if (!selectedMod2ListVal) {
      // If searchText is empty, you may want to reset or clear any existing data
      setMod2List([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }


    for (const rowIndex of mod2AllCheckbox) {
      const item = tableDetails[rowIndex];

      item.Mod2 = selectedMod2Data;
    }


    var inputStruct =
    {
      modName: selectedMod2ListVal
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetModList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        console.log("ModLists of " + CommonAPIConstants.GetModList, modData);


        if (Array.isArray(modData)) {
          setMod2List(
            modData.map((item) => {
              if (item && typeof item === 'object' && 'Value' in item) {
                return {
                  val: item.Value.split(' | ')[0],
                };
              } else {
                console.error('Invalid item in modData:', item);
                return null;
              }
            })
          );
        } else {
          setMod2List([]);
        }


      })
      .catch((error) => {
        console.error('Error fetching Mod names:', error);

      });
  };



  useEffect(() => {

    fetchMod2Data(selectedMod2ListVal);
  }, [selectedMod2ListVal]);

  const handleMod2Data = (suggestion) => {
    const concatenatedValue = `${suggestion.val}-${suggestion.val}`;

    setSelectedMod2ListVal(concatenatedValue);

    setSelectedMod2Data(suggestion.val)
    console.log('Selected suggestion:', suggestion);
  };


  const handleMod2KeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedMod2ListVal === '' && mod2List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setMod2List([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchMod2Data(selectedMod2ListVal.slice(0, -1))//Remove the last character from searchText

      }
    }
  }



  //Fetch Mod3 Suggestions List


  const fetchMod3Data = () => {

    if (!selectedMod3ListVal) {
      // If searchText is empty, you may want to reset or clear any existing data
      setMod3List([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }


    for (const rowIndex of mod3AllCheckbox) {
      const item = tableDetails[rowIndex];

      item.Mod3 = selectedMod3Data;
    }

    var inputStruct =
    {
      modName: selectedMod3ListVal
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetModList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        console.log("ModLists of " + CommonAPIConstants.GetModList, modData);


        if (Array.isArray(modData)) {
          setMod3List(
            modData.map((item) => {
              if (item && typeof item === 'object' && 'Value' in item) {
                return {
                  val: item.Value.split(' | ')[0],
                };
              } else {
                console.error('Invalid item in modData:', item);
                return null;
              }
            })
          );
        } else {
          setMod3List([]);
        }


      })
      .catch((error) => {
        console.error('Error fetching Mod names:', error);

      });
  };



  useEffect(() => {

    fetchMod3Data(selectedMod3ListVal);
  }, [selectedMod3ListVal]);

  const handleMod3Data = (suggestion) => {
    const concatenatedValue = `${suggestion.val}-${suggestion.val}`;

    setSelectedMod3ListVal(concatenatedValue);

    setSelectedMod3Data(suggestion.val)
    console.log('Selected suggestion:', suggestion);
  };


  const handleMod3KeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedMod3ListVal === '' && mod3List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setMod3List([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchMod3Data(selectedMod3ListVal.slice(0, -1))//Remove the last character from searchText

      }
    }
  }


  // Fetch ICD1 Suggestion List


  const fetchDiag1DataList = () => {

    if (!selectedDiag1List) {

      setDiag1List([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }




    for (const rowIndex of diag1AllCheckbox) {
      const item = tableDetails[rowIndex];

      item.ICDCode = selectedDiag1ID;
    }


    var inputStruct =
    {
      icdName: selectedDiag1List
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data


        console.log("ICDLists of " + CommonAPIConstants.GetIcdList, diagData);

        setDiag1List(diagData)


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };



  useEffect(() => {

    fetchDiag1DataList(selectedDiag1List);
  }, [selectedDiag1List]);

  const handleDiag1DataList = (suggestion) => {
    setSelectedDiag1List(suggestion.Value);
    const diagID = suggestion.Value.split(' ')[0].trim();

    setSelectedDiag1ID(diagID)
    console.log('Selected suggestion diagID:', selectedDiag1ID);
  };


  const handleDiag1DataKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedDiag1List === '' && diag1List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag1List([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag1DataList(selectedDiag1List.slice(0, -1))//Remove the last character from searchText

      }
    }
  }




  //Fetch ICD2 Suggestion List

  const fetchDiag2DataList = () => {

    if (!selectedDiag2List) {

      setDiag2List([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }


    for (const rowIndex of diag2AllCheckbox) {
      const item = tableDetails[rowIndex];

      item.ICDCode2 = selectedDiag1ID;
    }



    var inputStruct =
    {
      icdName: selectedDiag2List
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data


        console.log("ICDLists of " + CommonAPIConstants.GetIcdList, diagData);

        setDiag2List(diagData)


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };



  useEffect(() => {

    fetchDiag2DataList(selectedDiag2List);
  }, [selectedDiag2List]);

  const handleDiag2DataList = (suggestion) => {
    setSelectedDiag2List(suggestion.Value);
    const diagID = suggestion.Value.split(' ')[0].trim();

    setSelectedDiag1ID(diagID)
    console.log('Selected suggestion diagID:', selectedDiag1ID);
  };


  const handleDiag2DataKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedDiag2List === '' && diag2List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag2List([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag2DataList(selectedDiag2List.slice(0, -1))//Remove the last character from searchText

      }
    }
  }


  //Fetch ICD3 Suggestion List


  const fetchDiag3DataList = () => {

    if (!selectedDiag3List) {

      setDiag3List([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }


    for (const rowIndex of diag3AllCheckbox) {
      const item = tableDetails[rowIndex];

      item.ICDCode3 = selectedDiag1ID;
    }


    var inputStruct =
    {
      icdName: selectedDiag3List
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data


        console.log("ICDLists of " + CommonAPIConstants.GetIcdList, diagData);

        setDiag3List(diagData)


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };



  useEffect(() => {

    fetchDiag3DataList(selectedDiag3List);
  }, [selectedDiag3List]);

  const handleDiag3DataList = (suggestion) => {
    setSelectedDiag3List(suggestion.Value);
    const diagID = suggestion.Value.split(' ')[0].trim();

    setSelectedDiag1ID(diagID)
    console.log('Selected suggestion diagID:', selectedDiag1ID);
  };


  const handleDiag3DataKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedDiag3List === '' && diag3List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag3List([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag3DataList(selectedDiag3List.slice(0, -1))//Remove the last character from searchText

      }
    }
  }



  //Fetch ICD4 Suggestion List


  const fetchDiag4DataList = () => {

    if (!selectedDiag4List) {

      setDiag4List([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }


    for (const rowIndex of diag4AllCheckbox) {
      const item = tableDetails[rowIndex];

      item.ICDCode4 = selectedDiag1ID;
    }



    var inputStruct =
    {
      icdName: selectedDiag4List
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data


        console.log("ICDLists of " + CommonAPIConstants.GetIcdList, diagData);

        setDiag4List(diagData)


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };



  useEffect(() => {

    fetchDiag4DataList(selectedDiag4List);
  }, [selectedDiag4List]);

  const handleDiag4DataList = (suggestion) => {
    setSelectedDiag4List(suggestion.Value);
    const diagID = suggestion.Value.split(' ')[0].trim();

    setSelectedDiag1ID(diagID)
    console.log('Selected suggestion diagID:', selectedDiag1ID);
  };


  const handleDiag4DataKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedDiag4List === '' && diag4List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag4List([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag4DataList(selectedDiag4List.slice(0, -1))//Remove the last character from searchText

      }
    }
  }






  const handleSyncedInputChange = (e) => {
    const newValue = e.target.value;
    setSyncedValue(newValue);

    const updatedRows = [...filteredTableDetails];
    unitCheckbox.forEach((index) => {
      updatedRows[index].Unit = newValue;
      let totalCharge = newValue * filteredTableDetails[index].Unitcharge;
      updatedRows[index].TotalCharge = parseFloat(totalCharge.toFixed(2));
    });

    setFilteredTableDetails(updatedRows);

  };






  const handleSyncedUnitCharge = (e) => {
    const newValue = e.target.value;
    setSyncedUnitchargeVal(newValue);

    const updatedRows = [...filteredTableDetails];
    UnitChargeRows.forEach((index) => {
      updatedRows[index].Unitcharge = newValue;
      let totalCharge = newValue * filteredTableDetails[index].Unit;
      updatedRows[index].TotalCharge = parseFloat(totalCharge.toFixed(2));
    });

    setFilteredTableDetails(updatedRows);

  };









  // Fetch Providers List for Dialogbox


  const fetchSearchProvidersList = () => {

    if (!selectedProviderText) {
      setProviderDataList([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }

    var inputStruct = {

      "sProviderName": selectedProviderText,
      "sPracticeID": userPracticeID,
      "LoggedInUserDetails": userData

    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + IntelliBillConstants.GetIntelliProvidersNames, myInputData);

    const response = fetch(APIConstants.BASE_URL + IntelliBillConstants.GetIntelliProvidersNames, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const providersData = parsedData.Data

        console.log("providersLists of " + IntelliBillConstants.GetIntelliProvidersNames, providersData);


        if (Array.isArray(providersData)) {
          // Correct the structure of filteredProviders
          const filteredProviders = providersData
            .filter(item => item.toLowerCase().includes(selectedProviderText.toLowerCase()))
            .map((item) => ({
              label: (item.split('$')[0]).split('|')[1].trim(),
              id: item.split('$')[1].trim(),
            }))
            .filter(item => item.label !== selectedProviderSuggestion.label);

          setProviderDataList(filteredProviders);
        } else {
          setProviderDataList([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching provider names:', error);
      });
  };


  const isProviderMounted = useRef(true);

  useEffect(() => {

    if (isProviderMounted.current) {
      isProviderMounted.current = false;
    } else {
      fetchSearchProvidersList(selectedProviderText);
    }
  }, [selectedProviderText]);




  const handleProviderSuggestionList = (suggestion) => {
    setSelectedProviderText(`${suggestion.label}`);
    setSelectedProviderSuggestion(`${suggestion.id}`);
    setProviderDataList([]);
    setSelectedPatientID(selectedPatientID)

    console.log('Selected suggestion:', selectedProviderSuggestion);

  };


  const handleProviderListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      // Handle backspace key
      if (selectedProviderText === '' && providerDataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setProviderDataList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchSearchProvidersList(selectedProviderText.slice(0, -1)) // Remove the last character from searchText

      }
    }
  }




  //Fetch CPT List

  const fetchSearchCPTList = () => {

    if (!selectedCPTList) {
      // If searchText is empty, you may want to reset or clear any existing data
      setCptDataList([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }



    var inputStruct =
    {
      cptCode: selectedCPTList
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetCPTList, myInputData);


    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetCPTList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const cptData = parsedData.Data

        const filteredCPTData = cptData.filter(item =>
          `${item.CPT_Code} ${item.CPTDescription}` !== selectedCPTList
        );

        setCptDataList(filteredCPTData);

        console.log("CPTLists of " + CommonAPIConstants.GetCPTList, cptDataList);
      })
      .catch((error) => {
        console.error('Error fetching CPT names:', error);

      });
  };



  useEffect(() => {
    // Fetch suggestions when the component mounts or when searchText changes
    fetchSearchCPTList(selectedCPTList);
  }, [selectedCPTList]);

  const handleSearchCPTList = (suggestion) => {
    setSelectedCPTList(`${suggestion.CPT_Code} ${suggestion.CPTDescription}`);
    setSelectedCPTCode(`${suggestion.CPT_Code}`);
    setCptDataList([]);
    setSelectedUnitValue(1);
    const billingFee = parseFloat(suggestion.Billing_Fee).toFixed(2);
    setSelectedUnitChargeValue(billingFee);

    console.log('Selected suggestion:', billingFee);
  };


  const handleCPTListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      // Handle backspace key
      if (selectedCPTList === '' && cptDataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setCptDataList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchSearchCPTList(selectedCPTList.slice(0, -1)) // Remove the last character from searchText

      }
    }
  }

  //Fetch Mod1 List

  const fetchModList = () => {

    if (!selectedModList) {
      // If searchText is empty, you may want to reset or clear any existing data
      setModDataList([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }



    var inputStruct =
    {
      modName: selectedModList
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetModList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        console.log("ModLists of " + CommonAPIConstants.GetModList, modData);


        if (Array.isArray(modData)) {
          setModDataList(
            modData.map((item) => {
              if (item && typeof item === 'object' && 'Value' in item) {
                return {
                  val: item.Value.split(' | ')[0],
                };
              } else {
                console.error('Invalid item in modData:', item);
                return null;
              }
            })
          );
        } else {
          setModDataList([]);
        }


      })
      .catch((error) => {
        console.error('Error fetching Mod names:', error);

      });
  };



  useEffect(() => {

    fetchModList(selectedModList);
  }, [selectedModList]);

  const handleModList = (suggestion) => {
    setSelectedModList(suggestion);


    console.log('Selected suggestion:', suggestion);
  };


  const handleModListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedModList === '' && modDataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setModDataList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchModList(selectedModList.slice(0, -1))//Remove the last character from searchText

      }
    }
  }


  //Fetch Mod2 SuggestionList



  const fetchMod2List = () => {

    if (!selectedMod2Value) {
      // If searchText is empty, you may want to reset or clear any existing data
      setMod2DataList([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }



    var inputStruct =
    {
      modName: selectedMod2Value
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetModList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        console.log("ModLists of " + CommonAPIConstants.GetModList, modData);


        if (Array.isArray(modData)) {
          setMod2DataList(
            modData.map((item) => {
              if (item && typeof item === 'object' && 'Value' in item) {
                return {
                  val: item.Value.split(' | ')[0],
                };
              } else {
                console.error('Invalid item in modData:', item);
                return null;
              }
            })
          );
        } else {
          setMod2DataList([]);
        }


      })
      .catch((error) => {
        console.error('Error fetching Mod names:', error);

      });
  };



  useEffect(() => {

    fetchMod2List(selectedMod2Value);
  }, [selectedMod2Value]);

  const handleMod2List = (suggestion) => {
    setSelectedMod2Value(suggestion);
    //setMod2DataList([]);

    console.log('Selected suggestion:', suggestion);
  };


  const handleMod2ListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedMod2Value === '' && mod2DataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setMod2DataList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchMod2List(selectedMod2Value.slice(0, -1))//Remove the last character from searchText

      }
    }
  }


  //Fetch Mod3 SuggestionList

  const fetchMod3List = () => {

    if (!selectedMod3Value) {
      // If searchText is empty, you may want to reset or clear any existing data
      setMod3DataList([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }



    var inputStruct =
    {
      modName: selectedMod3Value
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetModList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetModList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        console.log("ModLists of " + CommonAPIConstants.GetModList, modData);


        if (Array.isArray(modData)) {
          setMod3DataList(
            modData.map((item) => {
              if (item && typeof item === 'object' && 'Value' in item) {
                return {
                  val: item.Value.split(' | ')[0],
                };
              } else {
                console.error('Invalid item in modData:', item);
                return null;
              }
            })
          );
        } else {
          setMod3DataList([]);
        }


      })
      .catch((error) => {
        console.error('Error fetching Mod names:', error);

      });
  };



  useEffect(() => {

    fetchMod3List(selectedMod3Value);
  }, [selectedMod3Value]);

  const handleMod3List = (suggestion) => {
    setSelectedMod3Value(suggestion);
    // setMod3DataList([]);

    console.log('Selected suggestion:', suggestion);
  };


  const handleMod3ListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedMod3Value === '' && mod3DataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setMod3DataList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchMod3List(selectedMod3Value.slice(0, -1))//Remove the last character from searchText

      }
    }
  }



  //Fetch ICD1 Suggestion List                                                         

  const fetchDiag1List = () => {

    if (!selectedDiag1Value) {

      setDiag1DataList([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }



    var inputStruct =
    {
      icdName: selectedDiag1Value
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data


        console.log("ICDLists of " + CommonAPIConstants.GetIcdList, diagData);

        setDiag1DataList(diagData)


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };



  useEffect(() => {

    fetchDiag1List(selectedDiag1Value);
  }, [selectedDiag1Value]);

  const handleDiag1List = (suggestion) => {
    setSelectedDiag1Value(suggestion.Value);
    const diagID = suggestion.Value.split(' ')[0].trim();

    setSelectedDiag1ID(diagID)
    console.log('Selected suggestion diagID:', selectedDiag1ID);
  };


  const handleDiag1ListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedDiag1Value === '' && diag1DataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag1DataList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag1List(selectedDiag1Value.slice(0, -1))//Remove the last character from searchText

      }
    }
  }







  //Fetch ICD2 Suggestion List

  const fetchDiag2List = () => {

    if (!selectedDiag2Value) {

      setDiag2DataList([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }



    var inputStruct =
    {
      icdName: selectedDiag2Value
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        console.log("ICDLists of " + CommonAPIConstants.GetIcdList, modData);

        setDiag2DataList(modData)


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };



  useEffect(() => {

    fetchDiag2List(selectedDiag2Value);
  }, [selectedDiag2Value]);

  const handleDiag2List = (suggestion) => {
    setSelectedDiag2Value(suggestion.Value);
    const diagID = suggestion.Value.split(' ')[0].trim();

    setSelectedDiag2ID(diagID)
    console.log('Selected suggestion diagID:', selectedDiag2ID);
  };


  const handleDiag2ListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedDiag2Value === '' && diag2DataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag2DataList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag2List(selectedDiag2Value.slice(0, -1))//Remove the last character from searchText

      }
    }
  }


  //Fetch ICD3 Suggestion List
  const fetchDiag3List = () => {

    if (!selectedDiag3Value) {

      setDiag3DataList([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }



    var inputStruct =
    {
      icdName: selectedDiag3Value
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        console.log("ICDLists of " + CommonAPIConstants.GetIcdList, modData);

        setDiag3DataList(modData)


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };



  useEffect(() => {

    fetchDiag3List(selectedDiag3Value);
  }, [selectedDiag3Value]);

  const handleDiag3List = (suggestion) => {
    setSelectedDiag3Value(suggestion.Value);
    const diagID = suggestion.Value.split(' ')[0].trim();

    setSelectedDiag3ID(diagID)
    console.log('Selected suggestion diagID:', selectedDiag3ID);
  };


  const handleDiag3ListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedDiag3Value === '' && diag3DataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag3DataList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag3List(selectedDiag3Value.slice(0, -1))//Remove the last character from searchText

      }
    }
  }


  //Fetch ICD4 Suggestion List

  const fetchDiag4List = () => {

    if (!selectedDiag4Value) {

      setDiag4DataList([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }



    var inputStruct =
    {
      icdName: selectedDiag4Value
    }

    console.log('userData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetIcdList, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetIcdList, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data


        console.log("ICDLists of " + CommonAPIConstants.GetIcdList, modData);

        setDiag4DataList(modData)


      })
      .catch((error) => {
        console.error('Error fetching ICD names:', error);

      });
  };



  useEffect(() => {

    fetchDiag4List(selectedDiag4Value);
  }, [selectedDiag4Value]);

  const handleDiag4List = (suggestion) => {
    setSelectedDiag4Value(suggestion.Value);
    const diagID = suggestion.Value.split(' ')[0].trim();

    setSelectedDiag4ID(diagID)
    console.log('Selected suggestion diagID:', selectedDiag4ID);
  };


  const handleDiag4ListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      //Handle backspace key
      if (selectedDiag4Value === '' && diag4DataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag4DataList([]);


      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag4List(selectedDiag4Value.slice(0, -1))//Remove the last character from searchText

      }
    }
  }

















  const handlePracticeButtonClick = (btnIndicator, boxIndicator) => {

    console.log("btnIndicator:>>>>>>>>>>>", btnIndicator, boxIndicator);

    let npiValue = '';
    let taxonomyCode = '';


    if (boxIndicator === '32a') {
      if (btnIndicator === 'SUD') npiValue = '1174115034';
      else if (btnIndicator === 'Fami Med') npiValue = '1366992893';
      else if (btnIndicator === 'BH') npiValue = '1366029415';
      else if (btnIndicator === 'Lab') npiValue = '1154823953';
      else if (btnIndicator === 'DEMO') npiValue = "9875632410";

      const updatedBillingNPI = [...filteredTableDetails];


      for (const rowIndex of selected32ACheckbox) {
        if (filteredTableDetails[rowIndex]) {
          updatedBillingNPI[rowIndex].Claim32a = npiValue;
        }
      }

      setSelectedBillingNPI(updatedBillingNPI);
    } else if (boxIndicator === '33a') {
      if (btnIndicator === 'SUD') npiValue = '1174115034';
      else if (btnIndicator === 'Fami Med') npiValue = '1366992893';
      else if (btnIndicator === 'BH') npiValue = '1366029415';
      else if (btnIndicator === 'Lab') npiValue = '1154823953';
      else if (btnIndicator === 'DEMO') npiValue = "9875632410";

      const updatedCMS33a = [...filteredTableDetails];


      for (const rowIndex of selected33ACheckbox) {
        if (filteredTableDetails[rowIndex]) {
          updatedCMS33a[rowIndex].Claim33a = npiValue;
        }
      }

      setSelectedCMS33a(updatedCMS33a);
    } else if (boxIndicator === '33b') {
      if (btnIndicator === 'SUD') taxonomyCode = '261QR0405X';
      else if (btnIndicator === 'Fami Med') taxonomyCode = '193200000X';
      else if (btnIndicator === 'BH') taxonomyCode = '101Y00000X';
      else if (btnIndicator === 'Lab') taxonomyCode = '291U00000X';
      else if (btnIndicator === 'DEMO') taxonomyCode = "9875632410";

      const updatedCMS33b = [...filteredTableDetails];


      for (const rowIndex of selected33BCheckbox) {
        if (filteredTableDetails[rowIndex]) {
          updatedCMS33b[rowIndex].Claim33b = taxonomyCode;
        }
      }

      setSelectedCMS33b(updatedCMS33b);
    }

    console.log('Updated values for checked rows based on the button click');
  };











  const handleCMS33AValue = (index, e) => {

    const selectedValue = e.target.value
    setSelectedCMS33a(selectedValue);
    const updatedRows = [...filteredTableDetails];
    updatedRows[index].Claim33a = selectedValue;
    setFilteredTableDetails(updatedRows);

  }



  const handleCMS33BValue = (index, e) => {

    const selectedValue = e.target.value
    setSelectedCMS33b(selectedValue);
    const updatedRows = [...filteredTableDetails];
    updatedRows[index].Claim33b = selectedValue;
    setFilteredTableDetails(updatedRows);

  }




  const handleChangeBillingNPI = (index, e) => {
    const selectedValue = e.target.value
    setSelectedBillingNPI(selectedValue);
    const updatedRows = [...filteredTableDetails];
    updatedRows[index].Claim32a = selectedValue;
    setFilteredTableDetails(updatedRows);

  };







  const filteredProviders = practiceProvider.filter(provider => provider.Supervisor === '1' || provider.Supervisor === '3');

  const handleSelectFilterProviders = (index, e) => {
    const selectedValue = e.target.value;

    const updatedProviders = [...selectedFilterProvider];


    updatedProviders[index] = selectedValue;

    // Set the updated state
    setSelectedFilterProvider(updatedProviders);
    console.log("Updated ClearingHouse for row " + index, selectedValue);

  }




  useEffect(() => {
    if (filteredTableDetails?.length > 0) {
      const defaultProviders = filteredTableDetails.map(item => item.SupervisingProvider || "");
      setSelectedFilterProvider(defaultProviders);
    }
  }, [filteredTableDetails]);



  useEffect(() => {
    if (filteredTableDetails?.length > 0) {
      const defaultProviders = filteredTableDetails.map(item => item.Box17Indicator || "");
      setSelectedProvidersCategory(defaultProviders);
    }
  }, [filteredTableDetails]);





  //All clearingHouse Data


  const handleAllClearingHouse = () => {


    var inputStruct = {


      "sPracticeID": userPracticeID,

    }

    console.log('LoginuserData', userData);
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);
    console.log("input of" + CommonAPIConstants.GetAllclearingHouse, myInputData);

    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetAllclearingHouse, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response


        const parsedData = JSON.parse(data.d);

        const allClearingHouseData = parsedData.Data

        setSelectClearingHouse(allClearingHouseData);

        console.log("All clearing house" + CommonAPIConstants.GetAllclearingHouse, selectClearinghouse);



      })
      .catch((error) => {
        console.error('Error fetching All clearing house:', error);
      });
  };




  useEffect(() => {

    handleAllClearingHouse();

  }, []);











  const handleSuggestionSelect = (item) => {
    setSearchText(item.label);

    setSelectedData(item.label);


    setSPatID(item.val);
    console.log("PatientID", sPatID);



    setSuggestions([]);

  };







  const handleInputKeyPress = (event) => {
    if (event.key === 'Backspace') {
      // Handle backspace key
      if (searchText === '' && suggestions.length > 0) {
        setSuggestions([]);
        setSPatID('');

      } else {

        const updatedSearchText = searchText.slice(0, -1);
        setSearchText(updatedSearchText);


        fetchSuggestions(updatedSearchText);
      }
    } else if (event.key !== 'Enter') {
      // Handle other key presses
      setSearchText(event.target.value);
      fetchSuggestions(event.target.value);
    }
  }





  const fetchSuggestions = (text) => {

    console.log("selected Suggestion", searchText);

    if (selectedSearchFilter === 'pat') {
      fetchPatientNames(text);
    } else if (selectedSearchFilter === 'provider') {
      fetchProviders(text);
    } else if (selectedSearchFilter === 'ins') {
      fetchInsuranceCompanies(text);
    }
    else if (selectedSearchFilter === 'submitter') {
      fetchSubmittedBy(text);
    }
    else if (selectedSearchFilter === '') {
      setSearchText('');
      setSelectedSearchFilter('');
      setSPatID('');
    }

  }




  const handleFilterChange = (event) => {

    setIsTextBoxDisabled(selectedSearchFilter === '');


    setSearchText('');
    setSPatID('')

    const value = event.target.value;



    setSelectedSearchFilter(value);
    setSearchText('');
    setIsTextBoxDisabled(value === '');

    switch (value) {
      case "pat":
        setInsOrPatFilter("pat");
        break;
      case "ins":
        setInsOrPatFilter("ins");
        break;
      case "provider":
        setInsOrPatFilter("provider");
        break;
      case "submitter":
        setInsOrPatFilter("submitter");
        break;
      default:
        setInsOrPatFilter(" ");
        break;
    }
  };




  //Bind the Intelli Bill table details



  const handleTableDataClick = (DataValidationMessage) => {
    setLoading(true);

    setSelectedRows([])
    var MissingData = DataValidationMessage;

    if (MissingData != "") {

    }

    const sEmptyArr = [];

    const objInput = {

      sFromDate: startDate,
      sToDate: endDate,
      sFilterType: selectedDropdownValue,
      sFilterText: sPatID,
      sInsorPatFilter: insOrPatFilter,
      iPracticeID: userPracticeID + "",


    };



    localStorage.setItem("pendingClaimsData", JSON.stringify(objInput));

    var inputJSON = JSON.stringify(objInput);
    console.log("input of" + RejectedConstants.GetRejectedClaims, objInput);

    const url = `${APIConstants.BASE_URL_BILLING}${RejectedConstants.GetRejectedClaims}?sInputJSON=${inputJSON}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {

        const insData = JSON.parse(data);
        console.log("tableDetails", insData);

        const parsedTableData = insData.Data;
        const parsedClaimData = parsedTableData.objClaims;



        console.log("tableData of  " + RejectedConstants.GetRejectedClaims, parsedClaimData);
        console.log("cms33aData of  " + RejectedConstants.GetRejectedClaims, cms33aData);

        setTableDetails(parsedClaimData)
        dispatch(RejectedClaim(parsedClaimData.length))

        setTimeout(() => {
          setLoading(false);
          setFilteredTableDetails(parsedClaimData);
          setCMS33aData(parsedTableData.obj33A);
          setCMS33bData(parsedTableData.obj33B);
          setBillingNPIs(parsedTableData.objPracticeNPI);
        }, 100);



      })
      .catch((error) => {
        setError('API request failed');
        setLoading(false);
      });






  }












  //Updated claims functionality



  const handleUpdatedClaims = async (e, isSaveforApproval) => {

    console.log("selectedLocations", selectedLocation);
    console.log("selectedLOC", locations);
    console.log("Filterprovider", selectedFilterProvider);
    console.log("selected32a", selectedBillingNPI);
    console.log("33A", selectedCMS33a);
    console.log("33b", selectedCMS33b);
    console.log("Box17Indi", selectedProvidersCategory);
    console.log("Box17Indival", selectedFilterProvider);
    console.log("userdata", userData);





    console.log("isReadyforApproval", isSaveforApproval);



    const selectedDataArray = [];

    for (const rowIndex of selectedRows) {
      const item = tableDetails[rowIndex];

      console.log("selectedRows", item);
      var mod3 = item.Mod3
      if (mod3 == null) {
        mod3 = ""
      }


      var mod2 = item.Mod2
      if (mod2 == null) {
        mod2 = ""
      }

      var mod1 = item.Mod1
      if (mod1 == null) {
        mod1 = ""
      }



      var diag1 = item.ICDCode
      if (diag1 == null) {
        diag1 = ""
      }


      var diag2 = item.ICDCode2
      if (diag2 == null) {
        diag2 = ""
      }


      var diag3 = item.ICDCode3
      if (diag3 == null) {
        diag3 = ""
      }

      var diag4 = item.ICDCode4
      if (diag4 == null) {
        diag4 = ""
      }


      var priInsId = item.PrimaryIns
      if (priInsId == null) {
        priInsId = ""
      }


      var policynumber = item.PolicyNumber
      if (policynumber == null) {
        policynumber = ""
      }



      var serviceLocationCode = item.ServiceLocationCode
      if (serviceLocationCode == null) {
        serviceLocationCode = ""
      }

      var ExternalClaimID = item.ExternalClaimID
      if (ExternalClaimID == null) {
        ExternalClaimID = ""
      }


      var PostingDate = formatDOSDate(item.PostingDate)
      if (PostingDate == null) {
        PostingDate = ""
      }


      var RenderingProvider = item.RenderingProvider
      if (RenderingProvider == null) {
        RenderingProvider = ""
      }



      const selectedData = {


        ClaimID: item.ClaimID,
        PostingDate: PostingDate,
        PlaceofService: item.PlaceofService + "",
        PatientID: item.PatientID + "",
        Procedure: item.procedure,
        CPTRowID: item.CPTRowID,
        SchedulingProvider: item.SchedulingProvider + "",
        PrimaryIns: priInsId + "",
        Claim32a: selectedBillingNPI[rowIndex] + "",
        Claim33a: selectedCMS33a[rowIndex] + "",
        Claim33b: selectedCMS33b[rowIndex] + "",
        ServiceLocationCode: serviceLocationCode,
        DOS: formatDOSDate(item.DOS),
        RenderingProvider: RenderingProvider + "",
        PolicyNumber: policynumber,
        Mod1: mod1,
        Mod2: mod2,
        Mod3: mod3,
        ICDCode1: diag1,
        ICDCode2: diag2,
        ICDCode3: diag3,
        ICDCode4: diag4,
        Unit: item.Unit,
        UnitCharge: item.Unitcharge,
        TotalCharge: item.TotalCharge,
        ExternalClaimID: ExternalClaimID,
        Box17Indicator: selectedProvidersCategory + "",
        SupervisingProvider: selectedFilterProvider + "",
        PriorSec: item.PriorSec + ""


      }

      console.log("selectedData", selectedData);

      selectedDataArray.push(selectedData)


    }


    console.log("selectedDataarray", selectedDataArray);
    var inputStruct = {

      IsSaveforApproval: 1,
      ClearingHouse: ClearingHouse,
      PracticeID: userPracticeID,
      IsFromDenial: 0,
      UserID: userId,
      SelectedClaims: selectedDataArray,


    };

    var myInput = JSON.stringify({ objClaim: inputStruct });
    console.log("inputRow of" + CommonAPIConstants.SaveForApproval, myInput);
    const InputJson = JSON.stringify(myInput);


    try {


      const response = await fetch(APIConstants.BASE_URL_BILLING + CommonAPIConstants.SaveForApproval, {
        method: 'POST',


        headers: {

          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sAuthToken}`

        },

        body: InputJson
      })


      if (response.ok) {
        const responseData = await response.json();


        //const parsedData = JSON.parse(responseData.d);

        setUpdatedTableData(responseData)

        console.log("SelectedRespData of" + CommonAPIConstants.SaveForApproval, responseData);

        console.log("selectedtablerows", selectedRows.length);

        setShowSelectErrorModal(false);
        setShowConfirmSaveModal(false);
        setShowApprovalSaveModal(false);

        // Show the success modal after saving changes



        setShowSuccessModal(true);

        setSavedRowCount(selectedRows.length);

      } else {
        console.error('Error sending data to the API');
        setSavedRowCount(savedRowCount + selectedRows.length);

      }


      setSelectedRows([]);


    } catch (error) {
      console.error('An error occurred:', error);

    }

  }






  useEffect(() => {

    const filteredData = filteredTableDetails.filter(item => {

      if (
        selectedCheckedRadioButton === 'All' ||
        (selectedCheckedRadioButton === 'CheckedIn') ||
        (selectedCheckedRadioButton === 'Non-CheckedIn')
      ) {

        if (
          selectedStatusRadioButton === 'All' ||
          (selectedStatusRadioButton === 'Submitted' && item.ClaimStatus === 'Submitted') ||
          (selectedStatusRadioButton === 'Non-Submitted' && item.ClaimStatus !== 'Submitted')
        ) {
          return true;
        }
      }
      return false;
    });

    setFilteredTableDetails(filteredData);
  }, [selectedCheckedRadioButton, selectedStatusRadioButton]);


  const filterLocationData = (data, location, searchText) => {
    return data.filter(item => {

      if (location === 'all') {
        return true;
      } else {
        const locationToCompare = item.LocationNickname;

        return (

          (locationToCompare === location ||
            (location === 'Test Practice' && locationToCompare === 'TP1') ||
            (location === 'OH Secondary Center' && locationToCompare === 'Sec')
          )
        );
      }
    });
  };






  const filterTableData = () => {

    const filteredData = tableDetails.filter((item) => {

      return (
        item[selectedSearchFilter].toLowerCase().includes(searchText.toLowerCase())
      );
    });

    // Set the filtered data to your state
    setTableDetails(filteredData);
  };


  useEffect(() => {

    return () => setSelectedRows([]);
  }, []);





  const handleSelectAllChange = () => {
    const allSelected = tableDetails.every((_, index) => selectedRows.includes(index));

    if (allSelected && selectedRows.length === tableDetails.length) {
      // Deselect all checkboxes
      setSelectedRows([]);
      setSelectAllRowsChecked(false);
    } else {
      // Select all checkboxes
      setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));
      setSelectAllRowsChecked(true);
    }
  };




  const handleRowCheckboxChange = (index, item) => {
    console.log('Selected Rows:', item);
    if (selectedRows.includes(index)) {
      setSelectedRows(selectedRows.filter((selectedRow) => selectedRow !== index));
    } else {
      setSelectedRows([...selectedRows, index]);

    }
    setSelectAllRowsChecked(false);
  }





  const handleSelectLocationAllChange = () => {
    const allSelected = tableDetails.every((_, index) => selectedLocationRows.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setSelectedLocationRows([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setSelectedLocationRows(Array.from({ length: tableDetails.length }, (_, index) => index));

      setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));

      console.log("selectedServiceLocationrows", selectedLocationRows);
    }
  };



  const handleLocRowCheckboxChange = (index, item) => {
    setSelectedLocationRows((prevSelectedRows) => {
      if (prevSelectedRows.includes(index)) {
        // If already selected, remove from the list
        console.log('Selected Location Rows:', item);
        return prevSelectedRows.filter((selectedRow) => selectedRow !== index);
      } else {
        // If not selected, add to the list
        return [...prevSelectedRows, index];
      }
    });
    console.log("selectedLocationRows for loc DDL", selectedLocationRows);
  };

  // change the header dropdown for service

  const handleSelectChange = (e, index) => {
    const { value } = e.target;
    console.log("Location selected value :" + value);
    setSelectedServicelocation(value);


    // loop for table rows which will check if the checkbox of servicelocation column is checked then changed the value of servicelocation
    //dropdown as per the value of header dropdown

    const allSelected = tableDetails.every((_, index) => selectedLocationRows.includes(index));

    for (const curIndex of selectedLocationRows) {
      console.log("curIndex " + curIndex);
      const item = tableDetails[curIndex];
      console.log("item " + item.ServiceLocationCode);
      item.ServiceLocationCode = value;
      console.log("item " + item.ServiceLocationCode);
    }
  };











  useEffect(() => {
    // updateValueField();
  }, [selectedLocationRows, selectedValueLocRows, selectedServiceLocation]);














  const handleResubmitCodeChange = (index, e) => {
    const selectedValue = e.target.value;
    setresubmitCodeValue(selectedValue)


    const updatedRows = [...filteredTableDetails];
    updatedRows[index].ResubmitCode = selectedValue;

    // Set the updated state
    setFilteredTableDetails(updatedRows);



  };





  const handleOriginalClaim = (index, e) => {
    const selectedValue = e.target.value;
    setorignalClaimNum(selectedValue)


    const updatedRows = [...filteredTableDetails];
    updatedRows[index].PayerclaimRefNumber = selectedValue;

    // Set the updated state
    setFilteredTableDetails(updatedRows);



  };



  const handleUnitChargeAllChange = () => {
    const allSelected = tableDetails.every((_, index) => UnitChargeRows.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setUnitChargeRows([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setUnitChargeRows(Array.from({ length: tableDetails.length }, (_, index) => index));

      setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));
      console.log("selectedServiceLocationrows", UnitChargeRows);
    }
  };


  const handleUnitChargeRowCheckbox = (index) => {
    if (UnitChargeRows.includes(index)) {
      setUnitChargeRows(UnitChargeRows.filter((selectedRow) => selectedRow !== index));



    } else {
      setUnitChargeRows([...UnitChargeRows, index]);


    }
  };


  const handleSelectUnitAllChange = () => {
    const allSelected = tableDetails.every((_, index) => unitCheckbox.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setUnitCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setUnitCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));

      setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));

      console.log("selectedAllrows", unitCheckbox);
    }
  };


  const handleUnitRowCheckboxChange = (index) => {
    if (unitCheckbox.includes(index)) {
      setUnitCheckbox(unitCheckbox.filter((selectedRow) => selectedRow !== index));



    } else {
      setUnitCheckbox([...unitCheckbox, index]);


    }
  };


  const handleSelectDiag4AllChange = () => {
    const allSelected = tableDetails.every((_, index) => diag4AllCheckbox.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setDiag4AllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setDiag4AllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));

      setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));


      console.log("selectedAllrows", diag4AllCheckbox);
    }
  };


  const handleDiag4RowCheckboxChange = (index) => {
    if (diag4AllCheckbox.includes(index)) {
      setDiag4AllCheckbox(diag4AllCheckbox.filter((selectedRow) => selectedRow !== index));

      setSelectedRows([]);

    } else {
      setDiag4AllCheckbox([...diag4AllCheckbox, index]);
      setSelectedRows([...selectedRows, index]);

    }
  };

  const handleSelectDiag3AllChange = () => {
    const allSelected = tableDetails.every((_, index) => diag3AllCheckbox.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setDiag3AllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setDiag3AllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));

      setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));


      console.log("selectedAllrows", diag3AllCheckbox);
    }
  };


  const handleDiag3RowCheckboxChange = (index) => {
    if (diag3AllCheckbox.includes(index)) {
      setDiag3AllCheckbox(diag3AllCheckbox.filter((selectedRow) => selectedRow !== index));

      setSelectedRows([]);


    } else {
      setDiag3AllCheckbox([...diag3AllCheckbox, index]);
      setSelectedRows([...selectedRows, index]);


    }
  };


  const handleSelectDiag2AllChange = () => {
    const allSelected = tableDetails.every((_, index) => diag2AllCheckbox.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setDiag2AllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setDiag2AllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));

      setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));

      console.log("selectedAllrows", diag2AllCheckbox);
    }
  };


  const handleDiag2RowCheckboxChange = (index) => {
    if (diag2AllCheckbox.includes(index)) {
      setDiag2AllCheckbox(diag2AllCheckbox.filter((selectedRow) => selectedRow !== index));
      setSelectedRows([]);



    } else {
      setDiag2AllCheckbox([...diag2AllCheckbox, index]);
      setSelectedRows([...selectedRows, index]);


    }
  };



  const handleSelectDiag1AllChange = () => {
    const allSelected = tableDetails.every((_, index) => diag1AllCheckbox.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setDiag1AllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setDiag1AllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));

      setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));


      console.log("selectedAllrows", diag1AllCheckbox);
    }
  };


  const handleDiag1RowCheckboxChange = (index) => {
    if (diag1AllCheckbox.includes(index)) {
      setDiag1AllCheckbox(diag1AllCheckbox.filter((selectedRow) => selectedRow !== index));
      setSelectedRows([]);



    } else {
      setDiag1AllCheckbox([...diag1AllCheckbox, index]);
      setSelectedRows([...selectedRows, index]);


    }
  };


  const handleSelectMod3AllChange = () => {
    const allSelected = tableDetails.every((_, index) => mod3AllCheckbox.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setMod3AllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setMod3AllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));

      setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));


      console.log("selectedAllrows", mod3AllCheckbox);
    }
  };


  const handleMod3RowCheckboxChange = (index) => {
    if (mod3AllCheckbox.includes(index)) {
      setMod3AllCheckbox(mod3AllCheckbox.filter((selectedRow) => selectedRow !== index));

      setSelectedRows([]);

    } else {
      setMod3AllCheckbox([...mod3AllCheckbox, index]);
      setSelectedRows([...selectedRows, index]);

    }
  };





  const handleSelectMod2AllChange = () => {
    const allSelected = tableDetails.every((_, index) => mod2AllCheckbox.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setMod2AllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setMod2AllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));

      setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));


      console.log("selectedAllrows", mod2AllCheckbox);
    }
  };


  const handleMod2RowCheckboxChange = (index) => {
    if (mod2AllCheckbox.includes(index)) {
      setMod2AllCheckbox(mod2AllCheckbox.filter((selectedRow) => selectedRow !== index));
      setSelectedRows([]);


    } else {
      setMod2AllCheckbox([...mod2AllCheckbox, index]);
      setSelectedRows([...selectedRows, index]);

    }
  };



  const handleSelectMod1AllChange = () => {
    const allSelected = tableDetails.every((_, index) => mod1AllCheckbox.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setMod1AllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setMod1AllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));

      setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));


      console.log("selectedAllrows", mod1AllCheckbox);
    }
  };


  const handleMod1RowCheckboxChange = (index) => {
    if (mod1AllCheckbox.includes(index)) {
      setMod1AllCheckbox(mod1AllCheckbox.filter((selectedRow) => selectedRow !== index));

      setSelectedRows([]);

    } else {
      setMod1AllCheckbox([...mod1AllCheckbox, index]);
      setSelectedRows([...selectedRows, index]);

    }
  };



  const handleSelectCPTAllChange = () => {
    const allSelected = tableDetails.every((_, index) => cptAllCheckbox.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setCptAllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setCptAllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));

      setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));


      console.log("selectedAllrows", cptAllCheckbox);
    }
  };


  const handleCPTRowCheckboxChange = (index) => {
    if (cptAllCheckbox.includes(index)) {
      setCptAllCheckbox(cptAllCheckbox.filter((selectedRow) => selectedRow !== index));

      setSelectedRows([]);

    } else {
      setCptAllCheckbox([...cptAllCheckbox, index]);
      setSelectedRows([...selectedRows, index]);

    }
  };



  const handleSelectProviderAllChange = () => {
    const allSelected = tableDetails.every((_, index) => providerAllCheckbox.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setProviderAllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setProviderAllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));

      setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));


      console.log("selectedAllrows", providerAllCheckbox);
    }
  };


  const handleProviderRowCheckboxChange = (index, item) => {
    if (providerAllCheckbox.includes(index)) {
      setProviderAllCheckbox(providerAllCheckbox.filter((selectedRow) => selectedRow !== index));
      setSelectedRows([]);
    } else {
      setProviderAllCheckbox([...providerAllCheckbox, index]);
      setSelectedRows([...selectedRows, index]);

    }



  };




  const handleSelectInsuranceAllChange = () => {
    const allSelected = tableDetails.every((_, index) => insuranceAllCheckbox.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setInsuranceAllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setInsuranceAllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));

      setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));


      console.log("selectedAllrows", insuranceAllCheckbox);
    }
  };


  const handleInsuranceRowCheckbox = (index) => {
    if (insuranceAllCheckbox.includes(index)) {
      // If the row is already selected, unselect it
      setInsuranceAllCheckbox(insuranceAllCheckbox.filter((selectedRow) => selectedRow !== index));
      setSelectedInsRows((prevSelectedRows) => prevSelectedRows.filter((selectedRow) => selectedRow !== index));
    } else {
      // If the row is not selected, select it
      setInsuranceAllCheckbox([...insuranceAllCheckbox, index]);
      setSelectedInsRows((prevSelectedRows) => [...prevSelectedRows, index]);
    }
  };
  console.log("selectedrows", insuranceAllCheckbox);


  useEffect(() => {

  }, [insuranceAllCheckbox]);







  const handle32aAllChange = () => {
    const allSelected = tableDetails.every((_, index) => selected32ACheckbox.includes(index));

    if (allSelected && selected32ACheckbox.length === tableDetails.length) {
      // Deselect all checkboxes
      setselected32ACheckbox([]);
      setselected32AllCheckbox(false);
    } else {
      // Select all checkboxes
      setselected32ACheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));
      setselected32AllCheckbox(true);
    }
  };






  const handle32ARowCheckbox = (index) => {

    if (selected32ACheckbox.includes(index)) {
      setselected32ACheckbox(selected32ACheckbox.filter((selectedRow) => selectedRow !== index));
    } else {
      setselected32ACheckbox([...selected32ACheckbox, index]);

    }
    setselected32AllCheckbox(false);
  }







  const handle33aAllChange = () => {
    const allSelected = tableDetails.every((_, index) => selected33ACheckbox.includes(index));

    if (allSelected && selected33ACheckbox.length === tableDetails.length) {
      // Deselect all checkboxes
      setselected33ACheckbox([]);
      setselected33AllCheckbox(false);
    } else {
      // Select all checkboxes
      setselected33ACheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));
      setselected33AllCheckbox(true);
    }
  };






  const handle33ARowCheckbox = (index) => {

    if (selected33ACheckbox.includes(index)) {
      setselected33ACheckbox(selected33ACheckbox.filter((selectedRow) => selectedRow !== index));
    } else {
      setselected33ACheckbox([...selected33ACheckbox, index]);

    }
    setselected33AllCheckbox(false);
  }



  const handle33BRowCheckbox = (index) => {

    if (selected33BCheckbox.includes(index)) {
      setselected33BCheckbox(selected33BCheckbox.filter((selectedRow) => selectedRow !== index));
    } else {
      setselected33BCheckbox([...selected33BCheckbox, index]);

    }
    setselected33BAllCheckbox(false);
  }







  const handle33BAllChange = () => {
    const allSelected = tableDetails.every((_, index) => selected33BCheckbox.includes(index));

    if (allSelected && selected33BCheckbox.length === tableDetails.length) {
      // Deselect all checkboxes
      setselected33BCheckbox([]);
      setselected33BAllCheckbox(false);
    } else {
      // Select all checkboxes
      setselected33BCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));
      setselected33BAllCheckbox(true);
    }
  };











  const handleOpenModal = () => {
    if (selectedRows.length === 0) {
      // Show error modal if no rows are selected



      setShowSelectErrorModal(true);
    } else {
      // Show confirm save modal if rows are selected

      setShowConfirmSaveModal(true);
    }
  };





  const handleICDOpenModal = () => {
    if (
      diag1AllCheckbox.length === 0 &&
      diag2AllCheckbox.length === 0 &&
      diag3AllCheckbox.length === 0 &&
      diag4AllCheckbox.length === 0
    ) {

      setShowICDErrorModal(true);
    } else {


      setICDConfirmSaveModal(true);
    }
  };




  const handleOpenApprovalModal = () => {
    if (selectedRows.length === 0) {
      // Show error modal if no rows are selected



      setShowSelectErrorModal(true);
    } else {
      // Show confirm save modal if rows are selected

      setShowApprovalSaveModal(true);
    }
  };

  const handleCloseClaimModal = () => {

    setCloseClaimsModal(true);

  }




  const handleCloseModals = () => {
    // Close all modals
    setShowSelectErrorModal(false);
    setShowConfirmSaveModal(false);
    setShowSuccessModal(false);
    setShowDeleteModal(false);
    setShowApprovalSaveModal(false);
    setCloseClaimsModal(false);
    setShowFaxModal(false);
    setShowICDErrorModal(false);
    setICDConfirmSaveModal(false)
  };


  const handleOpenDeleteModal = () => {
    if (selectedRows.length === 0) {


      setShowSelectErrorModal(true);
    } else {


      setShowDeleteModal(true);
    }
  };






  const handleServiceLocation = (index, e) => {
    const selectedValue = e.target.value;
    setSelectedService(selectedValue)


    const updatedRows = [...filteredTableDetails];
    updatedRows[index].ServiceLocationCode = selectedValue;

    // Set the updated state
    setFilteredTableDetails(updatedRows);

    console.log("Updated ClearingHouse for row " + index, selectedValue);

  };






  const handleClearinghouseChange = (index, e) => {
    const selectedValue = e.target.value;
    setClearingHouse(selectedValue)


    const updatedRows = [...filteredTableDetails];
    updatedRows[index].ClearingHouse = selectedValue;

    // Set the updated state
    setFilteredTableDetails(updatedRows);

    console.log("Updated ClearingHouse for row " + index, selectedValue);

  };





  useEffect(() => {

    console.log("ClearingHouse", ClearingHouse);
  }, []);









  //Checkeligibility functionality


  const handleCheckeligibility = async (e, rowIndex) => {



    console.log("selectedLOC", tableInsDetails.InsurerDOB);
    console.log("Filterprovider", tableInsDetails.InsCountryId);

    console.log("userdata", userData);


    const selectedDataArray = [];

    for (const rowIndex of insuranceAllCheckbox) {
      const item = tableInsDetails[rowIndex] || tableDetails[rowIndex];


      const eligibilityDOS = tableDetails[rowIndex].DOS;

      var InsCountryId = item.InsCountryId
      if (InsCountryId == null) {
        InsCountryId = ""
      }

      console.log("Dos", item.DOS);


      var inputStruct = {


        "PayerID": item.Id,
        "sIns_PolicyNumber": item.PolicyNumber + "",
        "patientID": item.PatientId,
        "sInsuredFName": item.InsurerFirstname,
        "sInsuredLName": item.InsurerLastName,
        "sInsuredStateName": item.InsuredStateName + "",
        "sInsuredDOB": item.InsurerDOB + "",
        "sInsCoID": InsCountryId,
        "EligibilityDOS": eligibilityDOS + "",
        "EligibilityRowIndex": rowIndex,
        "LoggedInUserDetails": userData



      };
    }
    var myInput = { sInputJSON: JSON.stringify(inputStruct) };
    console.log("inputRow of" + CommonAPIConstants.CheckPatientEligibility, myInput);
    myInput = JSON.stringify(myInput);


    try {


      const response = await fetch(APIConstants.BASE_URL + CommonAPIConstants.CheckPatientEligibility, {
        method: 'POST',


        headers: {

          'Accept': 'application/json',
          'Content-Type': 'application/json'

        },

        body: myInput
      })


      if (response.ok) {
        const responseData = await response.json();


        const parsedData = JSON.parse(responseData.d);


        setCheckEligibility(parsedData)



        console.log("SelectedRespData of" + CommonAPIConstants.CheckPatientEligibility, checkEligibility);

        console.log("selectedtablerows", selectedInsRows.length);


        setSavedRowCount(selectedInsRows.length);

      } else {
        console.error('Error sending data to the API');
        setSavedRowCount(savedRowCount + selectedInsRows.length);

      }


      setSelectedInsRows([]);




    } catch (error) {
      console.error('An error occurred:', error);

    }
    setShowIcon(false)
  }






  const handleDelete = async () => {


    const objClaim = [];

    for (const rowIndex of selectedRows) {
      const item = tableDetails[rowIndex];

      console.log("selectedRows", item);



      const patientName = `${item.LastName},${item.FirstName}`



      const selectedData = {

        PracticeID: userPracticeID,
        PatientID: item.PatientID + "",
        ClaimID: item.ClaimID,
        EncounterID: '',
        PatientName: patientName,
        DOS: formatDOSDate(item.DOS),
        IsDeletePermanently: 0,
        UserID: '0',
        UserFullName: '0'



      }

      console.log("selectedData", selectedData);

      objClaim.push(selectedData)


    }


    console.log("objClaim", objClaim);

    var myInput = JSON.stringify({ objClaim: objClaim });
    console.log("inputRow of" + CommonAPIConstants.DeleteClaim, myInput);

    var InputJson = JSON.stringify(myInput);


    try {



      const response = await fetch(APIConstants.BASE_URL_BILLING + CommonAPIConstants.DeleteClaim, {
        method: 'POST',


        headers: {

          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sAuthToken}`

        },

        body: InputJson
      })


      if (response.ok) {
        const responseData = await response.json();
        setShowDeleteModal(false)

        setUpdatedTableData(responseData)

        console.log("SelectedRespData of" + CommonAPIConstants.DeleteClaim, responseData);

        console.log("selectedtablerows", selectedRows.length);

        setShowSelectErrorModal(false);
        setShowConfirmSaveModal(false);
        setShowApprovalSaveModal(false);

        setDeleteRowCount(selectedRows.length);
        setDeleteSuccessModal(true)



        setFilteredTableDetails(prevTableDetails =>
          prevTableDetails.filter((_, index) => !selectedRows.includes(index))
        );


        setSelectedRows([]);






        resetDialogValues()


      } else {
        console.error('Error sending data to the API');
        setDeleteRowCount(deleteRowCount + selectedRows.length);

      }

    } catch (error) {
      console.error('An error occurred:', error);

    }


  };





  const DeleteclaimICDDetails = async () => {



    const JsonDataArr = [];

    [diag1AllCheckbox, diag2AllCheckbox, diag3AllCheckbox, diag4AllCheckbox].forEach((checkboxArray, index) => {
      checkboxArray.forEach(rowIndex => {
        const item = tableDetails[rowIndex];
        const clmnName = index === 0 ? "Diag1" : index === 1 ? "Diag2" : index === 2 ? "Diag3" : "Diag4";

        const input = {

          claimid: item.ClaimId + "",
          patientid: item.PatientId + "",
          procedure: item.CPT,
          practiceid: "",
          DOS: item.DOS + "",
          clmnName: clmnName


        }



        console.log("selectedData", input);

        JsonDataArr.push(input)

      });
    });

    const requestData = {
      JsonDataArr: JsonDataArr,
      LoggedInUserDetails: userData
    };




    var myInput = { sInputJSON: JSON.stringify(requestData) };
    console.log("inputRow of" + IntelliBillConstants.DeleteclaimICDDetails, myInput);
    myInput = JSON.stringify(myInput);


    try {


      const response = await fetch(APIConstants.BASE_URL + IntelliBillConstants.DeleteclaimICDDetails, {
        method: 'POST',


        headers: {

          'Accept': 'application/json',
          'Content-Type': 'application/json'

        },

        body: myInput
      })


      if (response.ok) {
        const responseData = await response.json();


        const parsedData = JSON.parse(responseData.d);


        console.log("SelectedRespData of" + IntelliBillConstants.DeleteclaimICDDetails, responseData);
        setICDConfirmSaveModal(false)
        handleTableDataClick();
        setDiag1AllCheckbox([])
        setDiag2AllCheckbox([])
        setDiag3AllCheckbox([])
        setDiag4AllCheckbox([])

      } else {
        console.error('Error sending data to the API');



      }





    } catch (error) {
      console.error('An error occurred:', error);

    }


  };












  const handleSortByDos = () => {

    const sortedTableDetails = [...filteredTableDetails].sort((a, b) => {
      const dateA = new Date(a.DOS);
      const dateB = new Date(b.DOS);

      if (sortDosDate === 'asc') {
        return dateA - dateB;
      } else {
        return dateB - dateA;
      }
    });

    // Toggle sorting order for the next click
    setSortDosDate(sortDosDate === 'asc' ? 'desc' : 'asc');

    // Update table details with sorted data
    setFilteredTableDetails(sortedTableDetails);

  };






  const sortDataByClaimId = () => {
    const sortedData = [...filteredTableDetails].sort((a, b) => {
      if (sortByClaimID === 'asc') {
        return a.ClaimID > b.ClaimID ? 1 : -1;
      } else {
        return a.ClaimID < b.ClaimID ? 1 : -1;
      }
    });

    setFilteredTableDetails(sortedData);
    setSortByClaimID(sortByClaimID === 'asc' ? 'desc' : 'asc');
  };




  const handleSortByName = () => {
    const newSortOrder = sortingOrder === 'asc' ? 'desc' : 'asc';
    setSortingOrder(newSortOrder);

    // Sort tableData array based on LastName and FirstName
    const sortedData = filteredTableDetails.sort((a, b) => {
      const nameA = `${a.LastName}, ${a.FirstName}`.toUpperCase();
      const nameB = `${b.LastName}, ${b.FirstName}`.toUpperCase();

      if (newSortOrder === 'asc') {
        return nameA.localeCompare(nameB);
      } else {
        return nameB.localeCompare(nameA);
      }
    });

    // Update state with sorted data
    setTableData([...sortedData]);
  };







  const handlesortByDOB = () => {

    const sortedTableDetails = [...filteredTableDetails].sort((a, b) => {
      const dateA = new Date(a.DOB);
      const dateB = new Date(b.DOB);

      if (sortDateOrder === 'asc') {
        return dateA - dateB;
      } else {
        return dateB - dateA;
      }
    });

    // Toggle sorting order for the next click
    setSortDateOrder(sortDateOrder === 'asc' ? 'desc' : 'asc');

    // Update table details with sorted data
    setFilteredTableDetails(sortedTableDetails);

  };



  const handleSortByInsurance = () => {

    setSortByInsurance(!sortByInsurance);

    if (sortByInsurance) {
      const sortedData = [...filteredTableDetails].sort((a, b) => b.InsuranceName.localeCompare(a.InsuranceName));
      setSortedInsData(sortedData);
      setFilteredTableDetails(sortedData);
    } else {
      const sortedData = [...filteredTableDetails].sort((a, b) => a.InsuranceName.localeCompare(b.InsuranceName));
      setSortedInsData(sortedData);
      setFilteredTableDetails(sortedData);
    }
  }












  useEffect(() => {

    resetDialogValues()

  }, [])
  //Add the row in DialogBox

  const handleAddRow = () => {

    resetDialogValues();

    if (!selectedCPTList) {

      setShowFaxError(true);
      setSaveFaxError(false);
      setShowFaxSaveMsg(false);
      return;

    }

    setSaveFaxError(false)
    console.log("patientID", selectedCPTPatientID);



    // Create a new row with the selected values
    const newRow = {



      DOS: startDate,
      PatientName: searchPatientText,
      ProvderName: selectedProviderText,
      ProviderId: selectedProviderSuggestion,
      CPT_Code: selectedCPTList,
      CPT: selectedCPTCode,
      patientID: selectedCPTPatientID,
      Mod1: selectedModList ? selectedModList.val : '',
      Mod2: selectedMod2Value ? selectedMod2Value.val : '',
      Mod3: selectedMod3Value ? selectedMod3Value.val : '',
      ICDCode: selectedDiag1ID,
      ICDCode2: selectedDiag2ID,
      ICDCode3: selectedDiag3ID,
      ICDCode4: selectedDiag4ID,
      Unit: selectedUnitValue,
      Unitcharge: selectedUnitChargeValue
    };


    setRows((prevRows) => [...prevRows, newRow]);


    setSelectedCPTList('');
    setSelectedModList(null);
    resetDialogValues();

  };


  const handleRemoveRow = (index) => {
    // Remove the row at the specified index
    setRows((prevRows) => prevRows.filter((_, i) => i !== index));
    resetDialogValues();
  };


  const handleSave = () => {

    setFilteredTableDetails((prevRows) => [...prevRows, ...rows]);


    setRows([]);

    setShowFaxModal(false);
  };





  const handleUnitChange = (index, newValue) => {
    const updatedRows = [...filteredTableDetails];
    updatedRows[index].Unit = newValue;

    let totalCharge = newValue * filteredTableDetails[index].Unitcharge;

    if (totalCharge == 0) {
      totalCharge = parseFloat(totalCharge.toFixed(2));
    }
    updatedRows[index].TotalCharge = totalCharge;
    setFilteredTableDetails(updatedRows);
  };




  const handleUnitchargeChange = (index, newValue) => {
    const updatedRows = [...filteredTableDetails];
    updatedRows[index].Unitcharge = newValue;

    let totalCharge = filteredTableDetails[index].Unit * newValue;

    if (totalCharge == 0) {
      totalCharge = parseFloat(totalCharge.toFixed(2));
    }
    updatedRows[index].TotalCharge = totalCharge;
    setFilteredTableDetails(updatedRows);
  };



  const handleTotalChargeChange = (index, newValue) => {
    const updatedRows = [...filteredTableDetails];
    updatedRows[index].TotalCharge = newValue === '' ? '' : newValue;
    setFilteredTableDetails(updatedRows);
  };





  const handleTotalChargeKeyDown = (index, e) => {
    if (e.key === 'Backspace') {
      e.preventDefault();
      const updatedRows = [...filteredTableDetails];
      updatedRows[index].TotalCharge = '';
      setFilteredTableDetails(updatedRows);
    }
  };








  const handleRowClick = (index) => {
    setActiveRow(index);
  };






  const formatDOSDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
  };




  useEffect(() => {
    console.log("Selected CMS 33a:", selectedCMS33a);
  }, [selectedCMS33a]);


  useEffect(() => {
    console.log("Selected CMS 33b:", selectedCMS33b);
  }, [selectedCMS33b]);



  const handleClaimsClick = () => {
    navigate('/pendingclaims')

  }






  useEffect(() => {
    // Filter the tableDetails based on both search terms

    const filteredData = tableDetails.filter(item =>
      // Filter by DOS
      (!searchByDOS || (formatDOSDate(item.DOS) && typeof formatDOSDate(item.DOS) === 'string' && item.DOS.toLowerCase().includes(searchByDOS.toLowerCase()))) &&
      (item.ClaimID && (typeof item.ClaimID === 'string' || typeof item.ClaimID === 'number') ? item.ClaimID.toString().toLowerCase().includes(searchByClaim.toLowerCase()) : true) &&
      // Filter by Patient Name
      (!searchByPatient || (item.LastName && typeof item.LastName === 'string' &&
        (item.LastName.toLowerCase().startsWith(searchByPatient.toLowerCase()) ||
          item.LastName.toLowerCase().includes(` ${searchByPatient.toLowerCase()}`)))) &&


      (!searchByDOB || (item.DOB && typeof item.DOB === 'string' && item.DOB.toLowerCase().includes(searchByDOB.toLowerCase()))) &&


      (!searchByInsuranceID || (item.InsuranceName && typeof item.InsuranceName === 'string' && item.InsuranceName.toLowerCase().includes(searchByInsuranceID.toLowerCase()))) &&


      (!searchByProvider || (item.ProvderName && typeof item.ProvderName === 'string' && item.ProvderName.toLowerCase().includes(searchByProvider.toLowerCase()))) &&

      // Filter by CPT Code
      (!searchByCPT || (item.CPT && typeof item.CPT === 'string' && item.CPT.toLowerCase().includes(searchByCPT.toLowerCase()))) &&


      (!searchByMod1 || (item.Mod1 && typeof item.Mod1 === 'string' && item.Mod1.toLowerCase().includes(searchByMod1.toLowerCase()))) &&
      (!searchByMod2 || (item.Mod2 && typeof item.Mod2 === 'string' && item.Mod2.toLowerCase().includes(searchByMod2.toLowerCase()))) &&
      (!searchByMod3 || (item.Mod3 && typeof item.Mod3 === 'string' && item.Mod3.toLowerCase().includes(searchByMod3.toLowerCase()))) &&


      (!searchByICD1 || (item.ICDCode && typeof item.ICDCode === 'string' && item.ICDCode.toLowerCase().includes(searchByICD1.toLowerCase()))) &&
      (!searchByICD2 || (item.ICDCode2 && typeof item.ICDCode2 === 'string' && item.ICDCode2.toLowerCase().includes(searchByICD2.toLowerCase()))) &&
      (!searchByICD3 || (item.ICDCode3 && typeof item.ICDCode3 === 'string' && item.ICDCode3.toLowerCase().includes(searchByICD3.toLowerCase()))) &&
      (!searchByICD4 || (item.ICDCode4 && typeof item.ICDCode4 === 'string' && item.ICDCode4.toLowerCase().includes(searchByICD4.toLowerCase()))) &&

      (!searchByReasonCode || (item.CPTLineAdjustCode && typeof item.CPTLineAdjustCode === 'string' && item.CPTLineAdjustCode.toLowerCase().includes(searchByReasonCode.toLowerCase()))) &&
      (!searchByReason || (item.ErrorDetails && typeof item.ErrorDetails === 'string' && item.ErrorDetails.toLowerCase().includes(searchByReason.toLowerCase())))

    );


    setFilteredTableDetails(searchByDOS || searchByPatient || searchByDOB || searchByInsuranceID || searchByProvider || searchByClaim
      || searchByCPT || searchByMod1 || searchByMod2 || searchByMod3 || searchByICD1 || searchByICD2 || searchByICD3 || searchByICD4 || searchByReason || searchByReasonCode
      ? filteredData : tableDetails);

  }, [tableDetails, searchByDOS, searchByPatient, searchByDOB, searchByInsuranceID, searchByProvider, searchByCPT,
    searchByMod1, searchByMod2, searchByMod3, searchByICD1, searchByICD2, searchByICD3, searchByICD4, searchByClaim, searchByReasonCode, searchByReason]);






  const handlePrint = () => {
    window.print();
  };




  const tableRef = useRef('');


  const exportToExcel = () => {
    const pagename = 'RejectedClaims';
    const table = tableRef.current;
    let sPrintableData = table ? table.innerHTML : '';

    const vRegEx = new RegExp("gvClosedClaims", "");
    sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");

    console.log('Table HTML:', sPrintableData);

    const PrintableDataDetails = {
      PrintableData: sPrintableData,
      PageName: pagename,
    };

    const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
    const InputJSON = JSON.stringify(InputJSONLevelOne);

    console.log("Input of Excel", InputJSON);

    fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExcelFile, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: InputJSON,
    })
      .then(response => response.json()) // Parse the response as JSON
      .then(data => {
        console.log('API response:' + FilesAPIConstants.ExcelFile, data);

        if (data && data[2]) {

          const url = data[2];
          window.open(url, '_blank');

        }
      })
      .catch(error => {
        console.error('Export to Excel failed', error);
      });
  };





  const exportToPDF = () => {
    const pagename = 'RejectedClaims';
    const table = tableRef.current.parentNode;
    let sPrintableData = table ? table.innerHTML : '';

    const vRegEx = new RegExp("gvClosedClaims", "");
    sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");

    console.log('Table HTML:', sPrintableData);

    const PrintableDataDetails = {
      PrintableData: sPrintableData,
      PageName: pagename,
    };

    const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
    const InputJSON = JSON.stringify(InputJSONLevelOne);

    console.log("Input of Excel", InputJSON);

    fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExportPdfFile, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: InputJSON,
    })
      .then(response => response.json()) // Parse the response as JSON
      .then(data => {
        console.log('API response:' + FilesAPIConstants.ExportPdfFile, data);

        if (data && data[2]) {

          const url = data[2];
          window.open(url, '_blank');


        }
      })
      .catch(error => {
        console.error('Export to PDF failed', error);
      });
  };





  const GetPDFCMS = (item) => {

    console.log("PDF Data", item);


    const claimFilters = {

      PracticeID: userPracticeID,
      ClaimID: item.ClaimID,
      PatientID: item.PatientId,

    };


    const sInputJSON = JSON.stringify(claimFilters);

    console.log("Input of PDF" + CommonAPIConstants.GetPDFCMS1500, sInputJSON);

    const url = `${APIConstants.BASE_URL_BILLING}${CommonAPIConstants.GetPDFCMS1500}?sInputJSON=${sInputJSON}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then(response => response.json()) // Parse the response as JSON
      .then(data => {
        console.log('API response:' + CommonAPIConstants.GetPDFCMS1500, data);

        if (data && data) {

          const url = data.documentURL;
          window.open(url, '_blank');


        }
      })
      .catch(error => {
        console.error(' PDF failed', error);
      });
  };





  const GetProviderPDF = (item) => {

    console.log("PDF Data", item);


    const claimFilters = {
      AddedUserID: 0,
      iPracticeID: userPracticeID,
      AddedUserRoleID: 0,
      sPatientID: item.PatientId,
      sFromDate: formatDOSDate(item.DOS),
      sCPT: item.CPT
    };


    const sInputJSON = JSON.stringify(claimFilters);

    console.log("Input of PDF" + FilesAPIConstants.PdfFile, sInputJSON);

    const url = `${APIConstants.BASE_URL_BILLING}${FilesAPIConstants.PdfFile}?sInputJSON=${sInputJSON}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then(response => response.json()) // Parse the response as JSON
      .then(data => {
        console.log('API response:' + FilesAPIConstants.PdfFile, data);

        if (data && data[0]) {

          const url = JSON.parse(data);
          window.open(url[0], '_blank');


        }
      })
      .catch(error => {
        console.error(' PDF failed', error);
      });
  };



  const handleDosLinkClick = (item) => {
    const claimId = item.ClaimID;

    localStorage.setItem('selectedClaimItem', JSON.stringify(item));

    const url = `/#/transactionlogs/${claimId}`;
    window.open(url, '_blank');
  };


  const handlePatLinkClick = (item) => {
    const url = `/#/patient-dashboard/${item.PatientID}/primary-insurance`;

    console.log("PatientID>>>", item.PatientID);
    localStorage.setItem("RejectedPatientID", item.PatientID);

    window.open(url, '_blank');
  };




  const handleLinkClick = (item) => {
    const url = `/#/new-encounter/${item.ClaimID}`;
    window.open(url, '_blank');
  };




  const handleProviderCategoryChange = (rowIndex, value, patientID) => {
    setSelectedProvidersCategory((prev) => ({
      ...prev,
      [rowIndex]: value,
    }));

    if (value === "DN") {
      getPhysicianDropdown(patientID);
    }
  };



  const getPhysicianDropdown = (patientID) => {
    if (!patientID) return;

    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientRefPhysician}?PatientID=${patientID}`;



    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`

      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {


        const parsedData = JSON.parse(data);

        setPhysicianDropdownData((prev) => ({
          ...prev,
          [patientID]: parsedData,
        }));

        setLoading(false);
      })

      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };




  return (
    <>





      <div className='main-container'>
        <div className='container-style'>

          <div className='table_style'>


            <div className='intelli-row-style '>



              <div>


                <select name="select" style={{ height: '25px', height: '30px', marginTop: '5px' }}
                  value={selectedDropdownValue}
                  onChange={(e) => setSelectedDropdownValue(e.target.value)}
                >

                  <option value="DOS" >DOS</option>

                  <option value="DOA" >To Approve</option>
                  <option value="DOSub" >Submit Date</option>
                </select>

              </div>




              <div className="datepicker-container mt-1" style={{ marginLeft: '5px', zIndex: 10, }}>
                <label>From:</label>
                <DatePicker
                  selected={startDate}
                  onChange={handleStartDateChange}
                  dateFormat="MM/dd/yyyy"
                  maxDate={new Date()}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  yearDropdownItemNumber={100}
                  readOnly={isHideChecked}
                  className={`clnImgTextBoxes ${startDate ? 'default-selected' : ''}`}
                  placeholderText="MM/dd/yyyy"

                  calendarContainer={CalendarStartContainer}
                  open={isStartOpen}
                  onFocus={() => setIsStartOpen(true)}
                  onInputClick={() => setIsStartOpen(true)}
                  onClickOutside={() => setIsStartOpen(false)}


                  renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                    const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                    const selectedMonth = selectedDate.getMonth();
                    const selectedYear = selectedDate.getFullYear();

                    return (
                      <div>
                        <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                          {"<"}
                        </button>
                        <select
                          value={selectedMonth}
                          onChange={({ target: { value } }) => changeMonth(Number(value))}
                        >
                          {getMonths(selectedYear)}
                        </select>
                        <select
                          value={selectedYear}
                          onChange={({ target: { value } }) => changeYear(Number(value))}
                        >
                          {Array.from({ length: 100 }, (v, k) => (
                            <option key={k} value={new Date().getFullYear() - k}>
                              {new Date().getFullYear() - k}
                            </option>
                          ))}
                        </select>
                        <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                          {">"}
                        </button>
                      </div>
                    );
                  }}
                />
              </div>

              <div className="datepicker-container mt-1" style={{ marginLeft: '5px', zIndex: 10 }}>
                <label>To:</label>
                <DatePicker
                  selected={endDate}
                  onChange={handleEndDateChange}
                  dateFormat="MM/dd/yyyy"
                  maxDate={new Date()}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  yearDropdownItemNumber={100}
                  className={`clnImgTextBoxes ${endDate ? 'default-selected' : ''}`}
                  placeholderText="MM/dd/yyyy"
                  popperPlacement="bottom-start"
                  readOnly={isHideChecked}

                  calendarContainer={CalendarContainer}
                  open={isEndOpen}
                  onFocus={() => setIsEndOpen(true)}
                  onInputClick={() => setIsEndOpen(true)}
                  onClickOutside={() => setIsEndOpen(false)}
                  renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                    const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                    const selectedMonth = selectedDate.getMonth();
                    const selectedYear = selectedDate.getFullYear();

                    return (
                      <div>
                        <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                          {"<"}
                        </button>
                        <select
                          value={selectedMonth}
                          onChange={({ target: { value } }) => changeMonth(Number(value))}
                        >
                          {getMonths(selectedYear)}
                        </select>
                        <select
                          value={selectedYear}
                          onChange={({ target: { value } }) => changeYear(Number(value))}
                        >
                          {Array.from({ length: 100 }, (v, k) => (
                            <option key={k} value={new Date().getFullYear() - k}>
                              {new Date().getFullYear() - k}
                            </option>
                          ))}
                        </select>
                        <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                          {">"}
                        </button>
                      </div>
                    );
                  }}
                />
              </div>



              <div className='search-style  mt-1'>

                <label>Search By:</label>
                <select name="select" className='select-style' value={selectedSearchFilter}
                  onChange={handleFilterChange}>


                  <option value="0"> </option>
                  <option value="pat">Patient Name</option>
                  <option value="provider">Rendering Provider</option>
                  <option value="ins">Insurance</option>
                  <option value="submitter">Submitted By</option>


                </select>
              </div>

              <div style={{ marginLeft: '10px', marginTop: '3px', width: '130px' }}>
                <input
                  type='text'
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyDown={handleInputKeyPress}

                  disabled={isTextBoxDisabled}
                  style={{ width: '140px' }}
                />
                <div className='autocomplete' style={{ zIndex: '10' }}>
                  <ul className='list-style'>
                    {suggestions.map((suggestion) => (
                      <li key={suggestion.val} onClick={() => handleSuggestionSelect(suggestion)}>{suggestion.label}</li>
                    ))}
                  </ul>
                </div>
              </div>



              <div style={{ marginLeft: '20px', marginTop: '5px' }}>
                <FontAwesomeIcon onClick={(e) => handleTableDataClick(e)} icon={faMagnifyingGlass} />
              </div>



              <div style={{ marginLeft: '40px', marginTop: '2px' }}>
                <FontAwesomeIcon style={{ marginTop: '8px' }} onClick={handlePrint} icon={faPrint} />
                <FontAwesomeIcon style={{ marginLeft: '8px', color: 'green', marginTop: '8px' }} onClick={exportToExcel} icon={faFileExcel} />
                <FontAwesomeIcon style={{ marginLeft: '8px', color: 'red', marginTop: '8px' }} onClick={exportToPDF} icon={faFilePdf} />


              </div>



            </div>
          </div>




          {loading && (
            <div className="overlay">
              <div className="spinner-container">
                <div className="spinner-grow text-danger" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <div className="spinner-grow text-warning" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <div className="spinner-grow text-info" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          )}




          {deleteSuccessModal && (

            <div className="alert alert-danger  mt-5" role="alert" style={{ marginLeft: '500px', width: '600px', position: 'absolute', zIndex: '10' }}>
              {`${deleteRowCount}  ${updatedTabledata}`}
            </div>

          )}



          {showSuccessModal && (
            <div className="alert alert-success aleart-modal mt-5" role="alert" style={{ marginLeft: '500px', width: '600px', position: 'absolute', zIndex: '10', marginTop: '10px' }}>
              {`${savedRowCount}  claim successfully Saved`}

            </div>
          )}






          <div className='table-container' style={{ height: '680px' }}>
            <table className="table table-hover table-striped table-bordered border-secondary responsive mt-1 mb-5 fixed-header" style={{ marginLeft: '4px', width: 'auto' }}>

              <thead>

                <tr className='align-top' >

                  <th className='col-sm col-th  text-white' style={{ backgroundColor: '#0173b7' }}>#</th>
                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }} >Location</th>
                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>

                    <Link style={{ color: 'white', cursor: 'pointer' }} onClick={handleSortByDos}>DOS</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByDOS}
                      onChange={(e) => setSearchByDOS(e.target.value)}
                    />
                  </th>

                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>
                    <Link style={{ color: 'white', cursor: 'pointer' }} onClick={sortDataByClaimId}>Claim ID</Link>
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByClaim}
                      onChange={(e) => setSearchByClaim(e.target.value)}
                    />
                  </th>


                  <th className='col=sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                    <Link style={{ color: 'white', cursor: 'pointer' }} onClick={handleSortByName}>Patient Name(2)</Link>

                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                      type='text'
                      placeholder='Search'
                      value={searchByPatient}
                      onChange={(e) => setSearchByPatient(e.target.value)}
                    />

                  </th>

                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>
                    <Link style={{ color: 'white', cursor: 'pointer' }} onClick={handlesortByDOB}>DOB(3)</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                      type='text'
                      placeholder='Search'
                      value={searchByDOB}
                      onChange={(e) => setSearchByDOB(e.target.value)}
                    />
                  </th>


                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>

                    <Link style={{ color: 'white', cursor: 'pointer' }} onClick={handleSortByInsurance}>Insurance (1a)</Link>
                    <br />




                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByInsuranceID}
                      onChange={(e) => setSearchByInsuranceID(e.target.value)}
                    />
                    <input style={{ marginLeft: '3px' }} type='checkbox'
                      onChange={() => handleSelectInsuranceAllChange('all')}
                    />
                  </th>
                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Rendering Provider (24 J)
                    <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByProvider}
                      onChange={(e) => setSearchByProvider(e.target.value)}
                    />
                    <input style={{ marginLeft: '3px' }} type='checkbox'
                      onChange={() => handleSelectProviderAllChange('all')}
                    />
                  </th>
                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>CPT (24 D)

                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByCPT}
                      onChange={(e) => setSearchByCPT(e.target.value)}
                    />
                    <input style={{ marginLeft: '3px' }} type='checkbox'
                      onChange={() => handleSelectCPTAllChange('all')}
                    />

                  </th>
                  <th className='col-sm col-th  text-white' style={{ backgroundColor: '#0173b7' }} onClick={handleAllClearingHouse}>Mod1
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByMod1}
                      onChange={(e) => setSearchByMod1(e.target.value)}
                    />
                    <input style={{ marginLeft: '3px' }} type='checkbox'
                      onChange={() => handleSelectMod1AllChange('all')}
                    />
                  </th>
                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Mod2
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByMod2}
                      onChange={(e) => setSearchByMod2(e.target.value)}
                    />
                    <input style={{ marginLeft: '3px' }} type='checkbox'
                      onChange={() => handleSelectMod2AllChange('all')}

                    />
                  </th>
                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Mod3
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByMod3}
                      onChange={(e) => setSearchByMod3(e.target.value)}
                    />
                    <input style={{ marginLeft: '3px' }} type='checkbox'
                      onChange={() => handleSelectMod3AllChange('all')}
                    />
                  </th>
                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Diag1
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByICD1}
                      onChange={(e) => setSearchByICD1(e.target.value)}
                    />
                    <input style={{ marginLeft: '3px' }} type='checkbox'
                      onChange={() => handleSelectDiag1AllChange('all')}
                    />

                    <FontAwesomeIcon style={{ cursor: 'pointer', marginLeft: '5px' }} onClick={handleICDOpenModal} icon={faTrashCan} />

                  </th>
                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Diag2
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByICD2}
                      onChange={(e) => setSearchByICD2(e.target.value)}
                    />
                    <input style={{ marginLeft: '3px' }} type='checkbox'
                      onChange={() => handleSelectDiag2AllChange('all')}
                    />

                    <FontAwesomeIcon style={{ cursor: 'pointer', marginLeft: '5px' }} onClick={handleICDOpenModal} icon={faTrashCan} />
                  </th>
                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Diag3
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByICD3}
                      onChange={(e) => setSearchByICD3(e.target.value)}
                    />
                    <input style={{ marginLeft: '3px' }} type='checkbox'
                      onChange={() => handleSelectDiag3AllChange('all')}
                    />

                    <FontAwesomeIcon style={{ cursor: 'pointer', marginLeft: '5px' }} onClick={handleICDOpenModal} icon={faTrashCan} />
                  </th>
                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Diag4
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByICD4}
                      onChange={(e) => setSearchByICD4(e.target.value)}
                    />
                    <input style={{ marginLeft: '3px' }} type='checkbox'
                      onChange={() => handleSelectDiag4AllChange('all')}
                    />

                    <FontAwesomeIcon style={{ cursor: 'pointer', marginLeft: '5px' }} onClick={handleICDOpenModal} icon={faTrashCan} />
                  </th>
                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Unit (24 G)
                    <input style={{ marginLeft: '3px' }} type='checkbox'
                      onChange={() => handleSelectUnitAllChange('all')}
                    />
                  </th>
                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Unit Charge (24 F)
                    <input style={{ marginLeft: '3px' }}
                      type='checkbox'
                      onChange={() => handleUnitChargeAllChange('all')}
                    />
                  </th>

                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Total Charge</th>




                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Service Loc(24 B)
                    <select name="select" style={{ color: 'black' }}
                      value={selectedServiceLocation}
                      onChange={(e) => handleSelectChange(e)}

                    >
                      {ServiceLocations.map((item, index) => (

                        <option key={index} value={item.ValueField} style={{ color: 'black' }}>{item.TextField}</option>
                      ))}
                    </select>
                    <input style={{ marginLeft: '3px' }}
                      type='checkbox'
                      onChange={(e) => handleSelectLocationAllChange('all')}
                    />
                  </th>



                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '360px', fontSize: '1rem' }}>
                    <label style={{ width: '140px', fontSize: '1rem' }}>   Resubmit Code (22)</label>
                    <label> 1 - Rejected</label>
                    <label> 7 - Denied</label>
                  </th>


                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '360px', fontSize: '1rem' }}>
                    Original Claim Number
                  </th>



                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '360px', fontSize: '1rem' }}>
                    (17)
                    <br />
                    <label style={{ width: '100px', fontSize: '1rem' }}>R - Referring</label>
                    <label> O - ORdering</label>
                    <label>S - Supervisor</label>
                  </th>


                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Location NPI (32 A)

                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '200px' }}>
                      {BillingNPIs.map((item, index) => (
                        <div key={index}>


                          {item.PracticeLabel && (
                            <button className="but" style={{ width: 'auto' }} onClick={() => handlePracticeButtonClick(item.PracticeLabel, '32a')} value={(`Selected ${item.PracticeLabel}`)}>
                              {item.PracticeLabel}
                            </button>
                          )}
                        </div>
                      ))}

                      <input style={{ marginLeft: '3px' }}
                        type='checkbox'
                        checked={selected32AllCheckbox}
                        onChange={(e) => handle32aAllChange('all')}
                      />

                    </div>




                  </th>

                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Billing NPI (33 A)

                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '200px' }}>
                      {BillingNPIs.map((item, index) => (
                        <div key={index}>


                          {item.PracticeLabel && (
                            <button className="but " onClick={() => handlePracticeButtonClick(item.PracticeLabel, '33a')} value={(`Selected ${item.PracticeLabel}`)}>
                              {item.PracticeLabel}
                            </button>
                          )}
                        </div>
                      ))}

                      <input style={{ marginLeft: '3px' }}
                        type='checkbox'
                        checked={selected33AllCheckbox}
                        onChange={(e) => handle33aAllChange('all')}
                      />


                    </div>


                  </th>


                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7', }}>Billing Taxonomy (33 B)

                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '200px' }}>
                      {BillingNPIs.map((item, index) => (
                        <div key={index}>


                          {item.PracticeLabel && (
                            <button className="but " onClick={() => handlePracticeButtonClick(item.PracticeLabel, '33b')} value={(`Selected ${item.PracticeLabel}`)}>
                              {item.PracticeLabel}
                            </button>
                          )}
                        </div>
                      ))}


                      <input style={{ marginLeft: '3px' }}
                        type='checkbox'
                        checked={selected33BAllCheckbox}
                        onChange={(e) => handle33BAllChange('all')}
                      />

                    </div>



                  </th>




                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Select
                    <input style={{ marginLeft: '3px' }} type='checkbox'
                      checked={selectAllRowsChecked}
                      onChange={() => handleSelectAllChange('all')}

                    />

                    <button className='btn-style2' onClick={handleOpenApprovalModal}>Save</button>
                    <FontAwesomeIcon style={{ cursor: 'pointer', marginLeft: '5px' }} onClick={handleOpenDeleteModal} icon={faTrashCan} />
                  </th>


                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Updated By</th>
                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Submit Date</th>
                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Submitted By</th>
                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Reason Code


                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByReasonCode}
                      onChange={(e) => setSearchByReasonCode(e.target.value)}
                    />

                  </th>
                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Reason

                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      value={searchByReason}
                      onChange={(e) => setSearchByReason(e.target.value)}
                    />
                  </th>
                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Notes</th>

                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Clearing House</th>

                </tr>

              </thead>

              <tbody>

                <tr className='align-top '>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>

                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <FontAwesomeIcon className='search-icon' icon={faMagnifyingGlass} />
                    <input type='text' className='search-box-style' placeholder='Add Provider'
                      value={selectedProviderData}

                      onChange={(e) => setselectedProviderData(e.target.value)}
                      onKeyDown={handleProviderKeyDown}
                    />

                    <div className='autocomplete' >
                      <ul className='list-style' style={{ width: '150px', color: 'black' }}>
                        {Array.isArray(suggestionProviders) && suggestionProviders.map((suggestion) => (
                          <li key={suggestion.val} onClick={() => handleProviderSuggestion(suggestion)}>
                            {suggestion.label}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </td>

                  <td>
                    <FontAwesomeIcon className='search-icon' icon={faMagnifyingGlass} />
                    <input type='text' className='search-box-style' placeholder='Add Procedure'
                      value={selectedCptValue}
                      onChange={(e) => setSelectedCptValue(e.target.value)}
                      onKeyUp={handleCPTKeyDown}
                    />

                    <div style={{ position: 'sticky' }}>
                      <ul className='list-style' style={{ width: '180px', color: 'black', fontSize: '0.8rem' }}>
                        {Array.isArray(cptValueList) && cptValueList.map((suggestion) => (
                          <li key={suggestion.val} onClick={() => handleCPTList(suggestion)}>
                            {suggestion.CPT_Code}-{suggestion.CPTDescription}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </td>
                  <td>
                    <FontAwesomeIcon className='search-icon' icon={faMagnifyingGlass} />
                    <input type='text' className='search-box-style' placeholder='Add Mod1'
                      value={selectedMod1Value}
                      onChange={(e) => setSelectedMod1Value(e.target.value)}
                      onKeyUp={handleMod1ListKeyDown}
                    />

                    <div style={{ position: 'sticky' }} >
                      <ul className='list-style' style={{ width: '100px', color: 'black', fontSize: '0.8rem' }}>
                        {Array.isArray(mod1List) && mod1List.map((suggestion) => (
                          <li onClick={() => handleMod1List(suggestion)}>
                            {suggestion.val != null ? (
                              suggestion.val
                            ) : (
                              // Handle the case where 'val' is null or undefined
                              <span style={{ color: 'red' }}>Invalid Value</span>
                            )}

                            -{suggestion.val != null ? (
                              suggestion.val
                            ) : (
                              // Handle the case where 'val' is null or undefined
                              <span style={{ color: 'red' }}>Invalid Value</span>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </td>
                  <td>
                    <FontAwesomeIcon className='search-icon' icon={faMagnifyingGlass} />
                    <input type='text' className='search-box-style' placeholder='Add Mod2'
                      value={selectedMod2ListVal}
                      onChange={(e) => setSelectedMod2ListVal(e.target.value)}
                      onKeyUp={handleMod2KeyDown}
                    />

                    <div style={{ position: 'sticky' }} >
                      <ul className='list-style' style={{ width: '100px', color: 'black', fontSize: '0.8rem' }}>
                        {Array.isArray(mod2List) && mod2List.map((suggestion) => (
                          <li onClick={() => handleMod2Data(suggestion)}>
                            {suggestion.val != null ? (
                              suggestion.val
                            ) : (
                              // Handle the case where 'val' is null or undefined
                              <span style={{ color: 'red' }}>Invalid Value</span>
                            )}

                            -{suggestion.val != null ? (
                              suggestion.val
                            ) : (
                              // Handle the case where 'val' is null or undefined
                              <span style={{ color: 'red' }}>Invalid Value</span>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </td>
                  <td>
                    <FontAwesomeIcon className='search-icon' icon={faMagnifyingGlass} />
                    <input type='text' className='search-box-style' placeholder='Add Mod3'
                      value={selectedMod3ListVal}
                      onChange={(e) => setSelectedMod3ListVal(e.target.value)}
                      onKeyUp={handleMod3KeyDown}
                    />
                    <div style={{ position: 'sticky' }} >
                      <ul className='list-style' style={{ width: '100px', color: 'black', fontSize: '0.8rem' }}>
                        {Array.isArray(mod3List) && mod3List.map((suggestion) => (
                          <li onClick={() => handleMod3Data(suggestion)}>
                            {suggestion.val != null ? (
                              suggestion.val
                            ) : (
                              // Handle the case where 'val' is null or undefined
                              <span style={{ color: 'red' }}>Invalid Value</span>
                            )}

                            -{suggestion.val != null ? (
                              suggestion.val
                            ) : (
                              // Handle the case where 'val' is null or undefined
                              <span style={{ color: 'red' }}>Invalid Value</span>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </td>
                  <td>
                    <FontAwesomeIcon className='search-icon' icon={faMagnifyingGlass} />
                    <input type='text' className='search-box-style' placeholder='Add Diag1'
                      value={selectedDiag1List}
                      onChange={(e) => setSelectedDiag1List(e.target.value)}
                      onKeyUp={handleDiag1DataKeyDown}
                    />

                    <div style={{ position: 'sticky' }} >
                      <ul className='list-style' style={{ width: '200px', color: 'black', fontSize: '0.8rem' }}>
                        {Array.isArray(diag1List) && diag1List.map((suggestion) => (
                          <li onClick={() => handleDiag1DataList(suggestion)}>
                            {suggestion.Value}

                          </li>
                        ))}
                      </ul>
                    </div>
                  </td>
                  <td>
                    <FontAwesomeIcon className='search-icon' icon={faMagnifyingGlass} />
                    <input type='text' className='search-box-style' placeholder='Add Diag2'
                      value={selectedDiag2List}
                      onChange={(e) => setSelectedDiag2List(e.target.value)}
                      onKeyUp={handleDiag2DataKeyDown}
                    />
                    <div style={{ position: 'sticky' }} >
                      <ul className='list-style' style={{ width: '200px', color: 'black', fontSize: '0.8rem' }}>
                        {Array.isArray(diag2List) && diag2List.map((suggestion) => (
                          <li onClick={() => handleDiag2DataList(suggestion)}>
                            {suggestion.Value}

                          </li>
                        ))}
                      </ul>
                    </div>
                  </td>
                  <td>
                    <FontAwesomeIcon className='search-icon' icon={faMagnifyingGlass} />
                    <input type='text' className='search-box-style' placeholder='Add Diag3'
                      value={selectedDiag3List}
                      onChange={(e) => setSelectedDiag3List(e.target.value)}
                      onKeyUp={handleDiag3DataKeyDown}
                    />

                    <div style={{ position: 'sticky' }} >
                      <ul className='list-style' style={{ width: '200px', color: 'black', fontSize: '0.8rem' }}>
                        {Array.isArray(diag3List) && diag3List.map((suggestion) => (
                          <li onClick={() => handleDiag3DataList(suggestion)}>
                            {suggestion.Value}

                          </li>
                        ))}
                      </ul>
                    </div>
                  </td>
                  <td>
                    <FontAwesomeIcon className='search-icon' icon={faMagnifyingGlass} />
                    <input type='text' className='search-box-style' placeholder='Add Diag4'
                      value={selectedDiag4List}
                      onChange={(e) => setSelectedDiag4List(e.target.value)}
                      onKeyUp={handleDiag4DataKeyDown}
                    />

                    <div style={{ position: 'sticky' }} >
                      <ul className='list-style' style={{ width: '200px', color: 'black', fontSize: '0.8rem' }}>
                        {Array.isArray(diag4List) && diag4List.map((suggestion) => (
                          <li onClick={() => handleDiag4DataList(suggestion)}>
                            {suggestion.Value}

                          </li>
                        ))}
                      </ul>
                    </div>
                  </td>


                  <td className='border-white'>
                    <input className='textboxes' style={{ width: '70px' }} type='text'
                      value={syncedValue}
                      onChange={(e) => handleSyncedInputChange(e)}
                    />
                  </td>
                  <td className='border-white'>
                    <input className='textboxes' style={{ width: '70px' }} type='text'
                      value={syncedUnitchargeVal}
                      onChange={(e) => handleSyncedUnitCharge(e)}
                    />
                  </td>

                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>



                {filteredTableDetails.map((item, index) => (



                  <tr className={`${activeRow === index ? 'table-warning' : ''} ${'table-success'}`}

                    key={index}
                    onClick={() => handleRowClick(index)}

                  >

                    <th scope="row" style={{ fontFamily: 'sans-serif', fontSize: '14px', fontWeight: '500' }}>{index + 1}</th>
                    <td><label>{item.AppLocationName}</label></td>
                    <td><label className='linkspan'>
                      <Link onClick={() => handleDosLinkClick(item)}> {formatDOSDate(item.DOS)}</Link>
                    </label></td>


                    <td> <Link onClick={() => handleLinkClick(item)}>{item.ClaimID}
                    </Link>


                      <FontAwesomeIcon style={{ marginLeft: '10px', color: 'red' }} onClick={() => GetPDFCMS(item)} icon={faFilePdf} />
                      <FontAwesomeIcon icon={faCircleInfo} title="CMS 1500 not present" />
                    </td>


                    <td><Link onClick={() => handlePatLinkClick(item)}>{item.LastName},{item.FirstName}
                    </Link>
                    </td>

                    <td><label className='label-style'>{formatDOSDate(item.DOB)}</label></td>
                    <td><label className='label-style' style={{ color: 'red' }}>{item.InsuranceID}</label>
                      <br />
                      <select name="select" id="" style={{ width: '130px' }} >

                        <option>{item.InsuranceName}</option>

                      </select>
                      <br />
                      <input style={{ float: 'right', marginRight: '10px', marginTop: '6px' }} type='checkbox'
                        key={index}
                        checked={insuranceAllCheckbox.includes(index)}
                        onChange={() => handleInsuranceRowCheckbox(index)}

                      />

                      {showIcon && !insuranceAllCheckbox.includes(index) ? (
                        <FontAwesomeIcon className='faexclamation-icon' icon={faTriangleExclamation} />
                      ) : null}


                    </td>
                    <td><label className='label-style'>{item.ProvderName}</label>
                      <FontAwesomeIcon style={{ marginLeft: '5px', color: 'red' }} onClick={() => GetProviderPDF(item)} icon={faFilePdf} />
                      <input style={{ marginLeft: '2px' }} type='checkbox'
                        checked={providerAllCheckbox.includes(index)}
                        onChange={() => handleProviderRowCheckboxChange(index, item)}
                      />
                    </td>

                    <td><label className='label-style'>{item.CPT}</label>
                      <input style={{ marginLeft: '2px' }} type='checkbox'
                        checked={cptAllCheckbox.includes(index)}
                        onChange={() => handleCPTRowCheckboxChange(index)}
                      />
                    </td>
                    <td><label>{item.Mod1}</label>
                      <input style={{ marginLeft: '2px' }} type='checkbox'
                        checked={mod1AllCheckbox.includes(index)}
                        onChange={() => handleMod1RowCheckboxChange(index)}
                      />
                    </td>
                    <td><label>{item.Mod2}</label>
                      <input type='checkbox'
                        checked={mod2AllCheckbox.includes(index)}
                        onChange={() => handleMod2RowCheckboxChange(index)}
                      />
                    </td>

                    <td><label>{item.Mod3}</label>
                      <input type='checkbox'
                        checked={mod3AllCheckbox.includes(index)}
                        onChange={() => handleMod3RowCheckboxChange(index)}
                      />
                    </td>
                    <td><label>{item.ICDCode}</label>
                      <input style={{ marginLeft: '2px' }} type='checkbox'
                        checked={diag1AllCheckbox.includes(index)}
                        onChange={() => handleDiag1RowCheckboxChange(index)}
                      />
                    </td>
                    <td><label>{item.ICDCode2}</label>
                      <input style={{ marginLeft: '2px' }} type='checkbox'
                        checked={diag2AllCheckbox.includes(index)}
                        onChange={() => handleDiag2RowCheckboxChange(index)}
                      />
                    </td>

                    <td><label>{item.ICDCode3}</label>
                      <input style={{ marginLeft: '2px' }} type='checkbox'
                        checked={diag3AllCheckbox.includes(index)}
                        onChange={() => handleDiag3RowCheckboxChange(index)}
                      />
                    </td>
                    <td><label>{item.ICDCode4}</label>
                      <input type='checkbox'
                        checked={diag4AllCheckbox.includes(index)}
                        onChange={() => handleDiag4RowCheckboxChange(index)}
                      />
                    </td>
                    <td>
                      <input className='text-boxes' type='number'
                        value={item.Unit}
                        onChange={(e) => handleUnitChange(index, e.target.value)}
                      />
                      <input style={{ marginLeft: '2px' }} type='checkbox'
                        checked={unitCheckbox.includes(index)}
                        onChange={() => handleUnitRowCheckboxChange(index)}
                      />
                    </td>

                    <td>
                      <input className='text-boxes' type='number'
                        value={Number(item.UnitCharge).toFixed(2)}
                        onChange={(e) => handleUnitchargeChange(index, e.target.value)}
                      />
                      <input style={{ marginLeft: '6px' }} type='checkbox'
                        checked={UnitChargeRows.includes(index)}
                        onChange={() => handleUnitChargeRowCheckbox(index)}
                      />
                    </td>
                    <td>
                      <input className='text-boxes' type='number'
                        value={Number(item.TotalCharge).toFixed(2)}
                        onChange={(e) => handleTotalChargeChange(index, e.target.value)}
                        onKeyDown={(e) => handleTotalChargeKeyDown(index, e)}
                      />

                    </td>




                    <td>


                      <select name="select" className=''
                        value={item.ServiceLocationCode}
                        onChange={(e) => handleServiceLocation(index, e)}
                      >
                        {filteredOptions.map((i, index) => (

                          <option key={index} value={i.ValueField}>{i.ValueField}</option>
                        ))}
                      </select>

                      <input style={{ marginLeft: '6px' }}
                        type='checkbox'

                        key={index}
                        checked={selectedLocationRows.includes(index)}
                        onChange={() => handleLocRowCheckboxChange(index, item)}

                      />


                    </td>


                    <td>
                      <input type='text'
                        value={item.ResubmitCode}

                        onChange={(e) => handleResubmitCodeChange(index, e)}

                      />
                    </td>


                    <td>

                      <input type='text'
                        value={item.PayerclaimRefNumber}

                        onChange={(e) => handleOriginalClaim(index, e)}

                      />
                    </td>

                    <td>


                      <div style={{ marginLeft: '1px' }}>


                        <select name="select" id="" className='option3 mt-1'
                          value={selectedProvidersCategory[index]}
                          onChange={(e) =>
                            handleProviderCategoryChange(index, e.target.value, item.PatientID)
                          }
                        >
                          {providerCategory.map((item, index) => (
                            <option value={item.Value}>{(item.Label)}</option>
                          ))}

                        </select>
                      </div>


                      <select
                        name="select"
                        className="option3 mt-1"
                        value={selectedFilterProvider[index] || "-1"}
                        onChange={(e) => handleSelectFilterProviders(index, e)}
                      >
                        <option value="-1">&lt;--Select--&gt;</option>

                        {(selectedProvidersCategory[index] === "DN"
                          ? physicianDropdownData[index] || []
                          : filteredProviders
                        )?.map((provider) => (
                          <option
                            key={provider.ID || provider.providerID}
                            value={String(provider.ID || provider.providerID)}
                          >
                            {provider.FirstName || provider.LastName
                              ? `${provider.FirstName ?? ""} ${provider.LastName ?? ""}`.trim() +
                              (provider.PhySpeciality?.trim()
                                ? ` - ${provider.PhySpeciality}`
                                : "")
                              : provider.providerName}
                          </option>
                        ))}
                      </select>

                    </td>



                    <td>
                      <select name="select" id="" className='option3'
                        value={item.Claim32a}
                        onChange={(e) => handleChangeBillingNPI(index, e)}
                      >
                        {BillingNPIs.map((item, index) => (
                          <option key={index} value={item.NPI}>{item.NamewithNPI}</option>

                        ))}
                      </select>

                      <input type='checkbox'
                        checked={selected32ACheckbox.includes(index)}
                        onChange={() => handle32ARowCheckbox(index)} />
                    </td>


                    <td>
                      <select name="select" className='select-style2'
                        value={item.Claim33a}
                        onChange={(e) => handleCMS33AValue(index, e)}>
                        {cms33aData.map((item, index) => (
                          <option key={index} value={item.NPI}>{item.NamewithNPI}</option>

                        ))}
                      </select>
                      <input type='checkbox'

                        checked={selected33ACheckbox.includes(index)}
                        onChange={() => handle33ARowCheckbox(index)} />
                    </td>
                    <td>
                      <select name="select" id="" className='option2'
                        value={item.Claim33b}
                        onChange={(e) => handleCMS33BValue(index, e)}>
                        {cms33bData.map((item, index) => (
                          <option style={{ width: "100px" }} key={index} value={item.TaxonomyCode}>
                            {item.NamewithTaxCode}
                          </option>
                        ))}


                      </select>

                      <input type='checkbox'

                        checked={selected33BCheckbox.includes(index)}
                        onChange={() => handle33BRowCheckbox(index)} />
                    </td>





                    <td>

                      <input
                        type='checkbox'
                        key={index}
                        checked={selectedRows.includes(index)}
                        onChange={() => handleRowCheckboxChange(index, item)}
                      />

                    </td>

                    <td>{item.UpdatedUserName}</td>



                    <td>{item.ClaimSubmitDate}</td>
                    <td>{item.SubmittedUserName}</td>
                    <td>{item.CPTLineAdjustCode}</td>
                    <td>{item.ErrorDetails}</td>
                    <td>
                      <textarea type='text' style={{ backgroundColor: item.ClaimNotes !== null ? 'lightgray' : 'white' }}
                        value={item.ClaimNotes}

                      />

                    </td>


                    <td>
                      <select name="select" style={{ width: '130px' }}
                        value={item.ClearingHouse}
                        onChange={(e) => handleClearinghouseChange(index, e)}
                      >

                        {selectClearinghouse.map((item, index) => (
                          <>

                            <option key={index} value={item.MCHID}>{item.ClearingHouseName}</option>
                          </>

                        ))}
                      </select>
                    </td>

                    <input type='hidden' value={item.PatientId} />
                    <input type='hidden' value={item.procedure} />
                    <input type='hidden' value={item.CPTRowID} />
                    <input type='hidden' value={item.providerid} />
                    <input type='hidden' value={item.ServiceLocationCode} />
                    <input type='hidden' value={item.PrimaryIns} />
                    <input type='hidden' value={item.DataValidationMessage} />


                  </tr>

                ))}


              </tbody>


            </table>








            {showSelectErrorModal && (

              <div className='alert-modal'>

                <p>please select atleast one claim...</p>
                <button className='btn btn-primary' onClick={handleCloseModals}>Ok</button>

              </div>

            )}

            {showICDErrorModal && (

              <div className='alert-modal'>

                <p>please select ICDs to Delete...</p>
                <button className='btn btn-primary' onClick={handleCloseModals}>Ok</button>

              </div>

            )}


            {ICDConfirmSaveModal && (
              <div className='alert-modal'>

                <p>Delete Selected ICDs?</p>
                <button className='btn btn-primary' onClick={handleCloseModals}>close</button>
                <button className='btn btn-primary' style={{ marginLeft: '40px' }} onClick={DeleteclaimICDDetails}>Delete</button>
              </div>

            )}


            {showConfirmSaveModal && (
              <div className='alert-modal'>

                <p>Are you sure to save?</p>
                <button className='btn btn-primary' onClick={handleCloseModals}>close</button>
                <button className='btn btn-primary' style={{ marginLeft: '40px' }} onClick={(e) => handleUpdatedClaims(e, 1)}>save</button>
              </div>

            )}



            {showApprovalSaveModal && (
              <div className='alert-modal'>

                <p>Are you sure to save for approval ?</p>
                <button className='btn btn-primary' onClick={handleCloseModals}>close</button>
                <button className='btn btn-primary' style={{ marginLeft: '40px' }} onClick={(e) => handleUpdatedClaims(e, 1)}>save</button>
              </div>

            )}













            {showDeleteModal && (

              <div className='alert-modal'>

                <p>Delete only for this session ?</p>
                <button className='btn btn-primary' onClick={handleCloseModals}>close</button>
                <button className='btn btn-primary' style={{ marginLeft: '40px' }} onClick={handleDelete}>Delete</button>
              </div>
            )}







            {closeClaimsModal && (
              <div className='alert-modal'>

                <div style={{ display: "block" }}>

                  <div>
                    <input type="password" />
                    <i class="fa fa-eye"></i>
                  </div>
                  <div >
                    <button type="button" className='btn btn-primary mt-1' onClick={handleCloseModals}>cancel</button>
                    <button type="button" className='btn btn-primary mt-1' style={{ marginLeft: '8px' }}>confirm</button>

                  </div>
                </div>
              </div>

            )}





          </div>



        </div>


      </div>



    </>
  )
}

export default RejectedClaims;